<template>
<div class="modal-mask create-mask"><!-- 200424수정(클래스추가) -->
    <div class="modal-wrapper">
        <div class="modal_size create_size">
            <a v-show="isPopupClose" href="javascript:" class="ui_close" type="button" @click="closePopup"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ getTitle }}</i>
                </dt>
                <dd class="scroll_fixed">
                    <!-- Register_wrap-->
                    <div class="register_wrap">
                        <div class="step_wrap">
                            <ul>
                                <!-- 활성화 STEP class 'active', 지나간 STEP class 'check'-->
                                <li :class="(processStep === 1) ? 'active' : (processStep > 1 ? 'check' : '')">
                                    <em>1</em>
                                    <p>{{ $t('MESSAGE.KNOWLEDGE.INSERT.DESCRIPTION') }}</p>
                                </li>
                                <li :class="(processStep === 2) ? 'active' : (processStep > 2 ? 'check' : '')">
                                    <em>2</em>
                                    <p>{{ $t('MESSAGE.KNOWLEDGE.INSERT.MODELLIST') }}</p>
                                </li>
                                <li :class="(processStep === 3) ? 'active' : (processStep > 3 ? 'check' : '')">
                                    <em>3</em>
                                    <p>{{ $t('MESSAGE.KNOWLEDGE.INSERT.PARTSLIST') }}</p>
                                </li>
                                <li :class="(processStep === 4) ? 'active' : (processStep > 4 ? 'check' : '')">
                                    <em>4</em>
                                    <p>{{ $t('MESSAGE.KNOWLEDGE.INSERT.VERHISTORY') }}</p>
                                </li>
                            </ul>
                        </div>
                        <table class="create_table">
                            <colgroup>
                                <col width="154">
                                <col width="*">
                                <col width="154">
                                <col width="*">
                                <col width="154">
                                <col width="*">
                            </colgroup>
                            <caption>
                                <em class="txt_mandatory">*</em>
                                {{ $t('FIELD.GLOBAL.MANDATORY') }}
                            </caption>
                            <tr>
                                <th>{{ $t('FIELD.GLOBAL.TYPE') }}<em class="txt_mandatory">*</em></th>
                                <td colspan="5">
                                    <fieldset class="ui_fieldset set_2">
                                        <div>
                                            <select
                                                id="BOARD_TYPE1"
                                                name="BOARD_TYPE1"
                                                v-model="BOARD_TYPE1"
                                                class="slt_white w100p"
                                                @change="changeBoardType1($event)"
                                                v-validation="{ groupId: 'description' }"
                                                :errorMessage="'MESSAGE.GLOBAL.VERIFICATION'"
                                                :disabled="isBoardAccess || isProcess || isServiceScript || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTTYPE') }}</option>
                                                <option v-if="boardType1List.length > 0"
                                                        v-for="item in boardType1List"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select
                                                id="BOARD_TYPE2"
                                                name="BOARD_TYPE2"
                                                v-model="BOARD_TYPE2"
                                                class="slt_white w100p"
                                                @change="changeBoardType2($event)"
                                                v-validation="{ groupId: 'description' }"
                                                :errorMessage="'MESSAGE.GLOBAL.VERIFICATION'"
                                                :disabled="isBoardAccess || isProcess || isServiceScript || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTTYPE') }}</option>
                                                <option v-if="boardType2List.length > 0"
                                                        v-for="item in boardType2List"
                                                        :key="item.code"
                                                        :value="item.code"
                                                        :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.GLOBAL.CATEGORY') }}<em class="txt_mandatory">*</em></th>
                                <td colspan="5">
                                    <fieldset class="ui_fieldset set_3">
                                        <div>
                                            <select class="slt_white w100p"
                                                    id="PRD_CATEGORY_CD1"
                                                    v-model="PRD_CATEGORY_CD1"
                                                    @change="changeCategory1($event)"
                                                    v-validation="{ groupId: 'description' }"
                                                    :errorMessage="'MESSAGE.GLOBAL.VERIFICATION'"
                                                    :disabled="isProcess || isServiceScript || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                                <option v-if="categoryComboList1.length > 0"
                                                        v-for="item in categoryComboList1"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100p"
                                                    id="PRD_CATEGORY_CD2"
                                                    v-model="PRD_CATEGORY_CD2"
                                                    @change="changeCategory2($event)"
                                                    :disabled="isProcess || isServiceScript || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                                <option v-if="categoryComboList2.length > 0"
                                                        v-for="item in categoryComboList2"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100p"
                                                    id="PRD_CATEGORY_CD3"
                                                    v-model="PRD_CATEGORY_CD3"
                                                    @change="changeCategory3($event)"
                                                    :disabled="isProcess || isServiceScript || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                                <option v-if="categoryComboList3.length > 0"
                                                        v-for="item in categoryComboList3"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.GLOBAL.SUBJECT') }}<em class="txt_mandatory">*</em></th>
                                <td colspan="5">
                                    <span class="clearable">
                                        <input  id="KNOWLEDGE_TITLE"
                                                type="text"
                                                class="text_input w100p"
                                                placeholder=""
                                                maxlength="270"
                                                v-model.trim="KNOWLEDGE_TITLE"
                                                v-validation="{ groupId: 'description' }"
                                                :errorMessage="'MESSAGE.KNOWLEDGE.REQUIRE.SUBJECT'"
                                                :disabled="isProcess || !getIsModify"
                                        >
                                        <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="isRepair">
                                <th>{{ $t('FIELD.GLOBAL.SYMPTOM') }}<em v-if="rtAndSb" class="txt_mandatory">*</em></th>
                                <td colspan="5">
                                    <!-- 단일 증상 코드인 경우 symptomList < 2 -->
                                    <fieldset class="ui_fieldset set_2" v-if="symptomList.length < 2">
                                        <div v-if="rtAndSb">
                                            <select class="slt_white w100p"
                                                    :id="getSymptomId('SYMPTOM_TYPE', 0)"
                                                    v-model="symptomList[0].SYMPTOM_TYPE"
                                                    @change="changeSymptomType(0, $event)"
                                                    v-validation="{ groupId: 'description' }"
                                                    :errorMessage="'MESSAGE.GLOBAL.VERIFICATION'"
                                                    :disabled="isProcess || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM') }}</option>
                                                <option v-if="symptomList[0].SYMPTOM_TYPEList.length > 0"
                                                        v-for="item in symptomList[0].SYMPTOM_TYPEList"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                        <div v-else>
                                            <select class="slt_white w100p"
                                                    :id="getSymptomId('SYMPTOM_TYPE', 0)"
                                                    v-model="symptomList[0].SYMPTOM_TYPE"
                                                    @change="changeSymptomType(0, $event)"
                                                    :disabled="isProcess || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM') }}</option>
                                                <option v-if="symptomList[0].SYMPTOM_TYPEList.length > 0"
                                                        v-for="item in symptomList[0].SYMPTOM_TYPEList"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <!-- 버튼이 생기면 w80p 클래스 변경 -->
                                            <select class="slt_white"
                                                    :id="getSymptomId('SYMPTOM_TYPE1', 0)"
                                                    :class="isRepair ? 'w80p' : 'w100p'"
                                                    v-model="symptomList[0].SYMPTOM_TYPE1"
                                                    :disabled="isProcess || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM') }}</option>
                                                <option v-if="symptomList[0].SYMPTOM_TYPE1List.length > 0"
                                                        v-for="item in symptomList[0].SYMPTOM_TYPE1List"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                            <span v-if="isRepair && getIsModify" class="in-btn-item" :class="isProcess ? 'disabled' : ''">
                                                <a href="javascript:" class="ico_btn_add" :title="$t('BUTTON.GLOBAL.ADD')" @click="btnAddSymptom">
                                                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.ADD') }}</span>
                                                </a>
                                            </span>
                                        </div>
                                    </fieldset>
                                    <!-- 멀티 증상 코드인 경우 symptomList > 1 -->
                                    <fieldset class="ui_fieldset set_2" v-else v-for="(symptom, idx) in symptomList">
                                        <div v-if="rtAndSb">
                                            <select class="slt_white w100p"
                                                    :id="getSymptomId('SYMPTOM_TYPE', idx)"
                                                    v-model="symptom.SYMPTOM_TYPE"
                                                    @change="changeSymptomType(idx, $event)"
                                                    v-validation="{ groupId: 'description' }"
                                                    :errorMessage="'MESSAGE.GLOBAL.VERIFICATION'"
                                                    :disabled="isProcess || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM') }}</option>
                                                <option v-if="symptom.SYMPTOM_TYPEList.length > 0"
                                                        v-for="item in symptom.SYMPTOM_TYPEList"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                        <div v-else>
                                            <select class="slt_white w100p"
                                                    :id="getSymptomId('SYMPTOM_TYPE', idx)"
                                                    v-model="symptom.SYMPTOM_TYPE"
                                                    @change="changeSymptomType(idx, $event)"
                                                    :disabled="isProcess || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM') }}</option>
                                                <option v-if="symptom.SYMPTOM_TYPEList.length > 0"
                                                        v-for="item in symptom.SYMPTOM_TYPEList"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <!-- 버튼이 생기면 w80p 클래스 변경 -->
                                            <select class="slt_white"
                                                    :id="getSymptomId('SYMPTOM_TYPE1', idx)"
                                                    :class="isRepair ? 'w80p' : 'w100p'"
                                                    v-model="symptom.SYMPTOM_TYPE1"
                                                    :disabled="isProcess || !getIsModify"
                                            >
                                                <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM') }}</option>
                                                <option v-if="symptomList[idx].SYMPTOM_TYPE1List.length > 0"
                                                        v-for="item in symptom.SYMPTOM_TYPE1List"
                                                        :key="item.code"
                                                        :value="item.code"
                                                >{{item.codeName}}</option>
                                            </select>
                                            <span v-if="getIsModify" class="in-btn-item" :class="isProcess ? 'disabled' : ''">
                                                <a href="javascript:" class="ico_btn_add" :title="$t('BUTTON.GLOBAL.ADD')" @click="btnAddSymptom">
                                                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.ADD') }}</span>
                                                </a>
                                                <a v-if="idx > 0" href="javascript:" class="ico_btn_remove" :title="$t('BUTTON.GLOBAL.REMOVE')" @click="btnRemoveSymptom(idx)">
                                                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.REMOVE') }}</span>
                                                </a>
                                            </span>
                                        </div>
                                    </fieldset>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.GLOBAL.IMPORTANT') }}
                                    <em class="ico_info">
                                        <i class="tooltip">{{ $t('MESSAGE.KNOWLEDGE.IMPORTANT.TOOLTIP') }}</i>
                                    </em>
                                </th>
                                <td>
                                    <label class="checkbox-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                        <input type="checkbox" name="importantYn" v-model="importantYn" :disabled="(isProcess || !getIsModify)" @change="setCheckImpRead($event)"><i class="check-icon"></i>
                                    </label>
                                </td>
                                <th>{{ $t('FIELD.GLOBAL.MUSTREAD') }}
                                    <em class="ico_info">
                                        <i class="tooltip">{{ $t('MESSAGE.KNOWLEDGE.MUSTREAD.TOOLTIP') }}</i>
                                    </em>
                                </th>
                                <td>
                                    <label class="checkbox-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                        <input type="checkbox" name="mustreadYn" v-model="mustreadYn" :disabled="(isProcess || !getIsModify)" @change="setCheckImpRead($event)"><i class="check-icon"></i>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <th v-if="!targetAllPass">
                                    {{ $t('FIELD.NOTICE.TARGET') }}
                                </th>
                                <td v-if="!targetAllPass">
                                    <fieldset class="ui_table">
                                        <span class="radio_item">
                                            <label v-if="!isRequestSharing" class="radiobox-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                <input type="radio" name="rdo1" value="S" v-model="DIST_TARGET" :disabled="(isProcess || !getIsModify)">
                                                <i class="radio-icon"></i>
                                                <em>{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</em>
                                            </label>
                                            <!-- Add Contents 에서는 Subsidiary 만 배포가능 -->
                                            <label v-if="getDistributor" class="radiobox-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                <input type="radio" name="rdo1" value="G" v-model="DIST_TARGET" :disabled="(isProcess || !getIsModify)">
                                                <i class="radio-icon"></i>
                                                <em>{{ $t('FIELD.GLOBAL.GLOBAL') }}</em>
                                            </label>
                                        </span>

                                        <!-- Add Contents 에서는 Subsidiary 만 배포가능 -->
                                        <span v-if="getDistributor" class="global_item" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                            <fragment v-if="DIST_TARGET === 'G' && selectSubsidiary.length > 0">
                                                <em name="selectSubsidiary" class="tooltip_box">
                                                    (
                                                        {{ selectSubsidiary.length }}
                                                        <template v-if="selectSubsidiary.length > 1"> Subsidiaries</template>
                                                        <template v-else> Subsidiary</template>
                                                    )
                                                    <i class="tooltip">{{ selectSubsidiary.join(', ') }}</i>
                                                </em>
                                            </fragment>

                                            <a
                                                v-if="DIST_TARGET === 'G' && processStep === 1 && getIsModify"
                                                href="javascript:"
                                                class="ico_write_global"
                                                @click="globalTargetPop"
                                                :disabled="isProcess">
                                                <span class="sr_only">{{ $t('BUTTON.KNOWLEDGE.GLOBALEDIT') }}</span>
                                            </a>
                                        </span>
                                    </fieldset>
                                </td>
                                <!-- 200708수정 위치이동 S -->
                                <th>
                                    {{ $t('FIELD.KNOWLEDGE.ALLOWSHARING') }}
                                    <em class="ico_info">
                                        <i class="tooltip">{{ $t('MESSAGE.KNOWLEDGE.ALLOWSHARING.TOOLTIP') }}</i>
                                    </em>
                                </th>
                                <td>
                                    <label class="checkbox-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                        <input type="checkbox" name="allowSharing" v-model="isAllowSharing" :disabled="(isProcess || !getIsModify)">
                                        <i class="check-icon"></i>
                                    </label>
                                </td>
                                <!-- 200708수정 위치이동 E -->

                                <!-- 20220720 ke01.liu -->
                                <th v-if="getMenuGrpDetailCd && getUserCorpCode">
                                     External Sharing
                                </th>
                                <td  v-if="getMenuGrpDetailCd && getUserCorpCode" :colspan="targetAllPass ? 3 : 1">
                                    <label class="checkbox-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                        <input type="checkbox" name="allowExternalSharing" v-model="isExternalSharing" :disabled="(isProcess || !getIsModify)">
                                        <i class="check-icon"></i>
                                    </label>
                                </td>
                                <!-- 20220720 ke01.liu -->
                            </tr>
                            <fragment v-if="isSCMSContents">
                                <tr>
                                    <th>{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                    <td colspan="5">
                                        <fieldset class="ui_fieldset pos-relative">
                                            <span class="date-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                <label>
                                                    <input id="fromDate" type="text" :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')" class="date_input w100p" :disabled="isProcess" readonly maxlength="20">
                                                    <a href="javascript:" id="icoFromDate" class="in_btn" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                        <!--i class="ico_date"></i-->
                                                        <span class="sr_only">{{ $t('FIELD.KNOWLEDGE.SEARCH.FROMDATE') }}</span>
                                                    </a>
                                                </label>
                                                <div id="from-picker-container" style="margin-top: -1px;"></div>
                                            </span>
                                            <em class="txt_space"></em>
                                            <span class="date-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                <label>
                                                    <input id="toDate" type="text" :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')" class="date_input w100p" :disabled="isProcess" readonly maxlength="20">
                                                    <a href="javascript:" id="icoToDate" class="in_btn" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                        <!--i class="ico_date"></i-->
                                                        <span class="sr_only">{{ $t('FIELD.KNOWLEDGE.SEARCH.TODATE') }}</span>
                                                    </a>
                                                </label>
                                                <div id="to-picker-container" style="margin-top: -1px;"></div>
                                            </span>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr v-if="showSerial">
                                    <th>{{ $t('FIELD.QNA.SERIAL.NUMBER') }}<em v-if="getGudieTypeVerifyUseYn && (getMenuCdSbYn || getMenuCdLocalSbYn)" class="txt_mandatory">*</em></th>
                                    <td colspan="5" id="snFields">
                                        <fieldset class="ui_fieldset" v-if="serialList.length < 2">
                                            <label class="date-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                <input type="text" class="text_input w100p" maxlength="20" :disabled="(isProcess || !getIsModify)" v-model="serialList[0].SERIAL_S" v-regex="'/[^a-z0-9]/gi'">
                                            </label>
                                            <em class="txt_space"></em>
                                            <label class="date-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                <input type="text" class="text_input w100p" maxlength="20" :disabled="(isProcess || !getIsModify)" v-model="serialList[0].SERIAL_E" v-regex="'/[^a-z0-9]/gi'">
                                            </label>
                                            <span v-if="getIsModify" class="in-btn-item" :class="isProcess ? 'disabled' : ''">
                                                <a href="javascript:" class="ico_btn_add" :title="$t('BUTTON.GLOBAL.ADD')" @click="btnAddSerial">
                                                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.ADD') }}</span>
                                                </a>
                                            </span>
                                        </fieldset>
                                        <!-- Add S/N Field -->
                                        <fieldset class="ui_fieldset" v-else v-for="(serial, idx) in serialList">
                                            <label class="date-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                <input type="text" class="text_input w100p" maxlength="20" :disabled="(isProcess || !getIsModify)" v-model="serial.SERIAL_S" v-regex="'/[^a-z0-9]/gi'">
                                            </label>
                                            <em class="txt_space"></em>
                                            <label class="date-wrap" :class="(isProcess || !getIsModify) ? 'disabled' : ''">
                                                <input type="text" class="text_input w100p" maxlength="20" :disabled="(isProcess || !getIsModify)" v-model="serial.SERIAL_E" v-regex="'/[^a-z0-9]/gi'">
                                            </label>
                                            <span v-if="getIsModify" class="in-btn-item" :class="isProcess ? 'disabled' : ''">
                                                <a href="javascript:" class="ico_btn_add" :title="$t('BUTTON.GLOBAL.ADD')" @click="btnAddSerial">
                                                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.ADD') }}</span>
                                                </a>
                                                <a v-if="idx > 0" href="javascript:" class="ico_btn_remove" :title="$t('BUTTON.GLOBAL.REMOVE')" @click="btnRemoveSerial(idx)">
                                                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.REMOVE') }}</span>
                                                </a>
                                            </span>
                                        </fieldset>
                                        <!-- // Add S/N Field -->
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                    <td>
                                        <select class="slt_white w100p" v-model="defectType" :disabled="(isProcess || !getIsModify)">
                                            <option value="" selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                            <option value="M">Common</option>
                                            <option value="C">Call</option>
                                            <option value="R">Repair</option>
                                        </select>
                                    </td>
                                    <th>{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}<em v-if="getGudieTypeVerifyUseYn && getMenuCdSbYn" class="txt_mandatory">*</em></th>
                                    <td>
                                    	<!-- // ke01.liu 2023-02-15 -->
                                        <select class="slt_white w100p"
                                        		v-model="guideType"
                                        		:disabled="(isProcess || !getIsModify)">
                                            <option value="" selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                            <option value="P">Parts Used</option>
						                    <option value="S">S/W & Firmware</option>
						                    <option value="A">Alternative Parts</option>
						                    <option value="O">On Site Check Guide</option>
						                    <option value="R">Repair Information & Tips</option>
						                    <!-- C23030008966  서비스블레틴 신규 guide type 추가  ke01.liu 2023-04-07 begin -->
						                    <option value="M">Manufacturing BOM Change</option>
						                    <!-- C23030008966  서비스블레틴 신규 guide type 추가  ke01.liu 2023-04-07 end -->
                                            <!-- <option value="H">H/W</option>
                                            <option value="S">S/W</option>
                                            <option value="M">Mechanical</option>
                                            <option value="A">Accessory</option>
                                            <option value="I">Info Sharing</option>
                                            <option value="E">Others</option> -->
                                        </select>
                                    </td>
                                </tr>
                            </fragment>
                            <tr>
                                <td colspan="6">
                                    <div class="tab_wrap">
                                        <ul class="tab_menu_03 tab_menus">
                                            <li :class="(processStep === 1) ? 'on' : ''">
                                                <a href="javascript:" :title="$t('FIELD.GLOBAL.DESCRIPTION')">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}<em class="txt_mandatory">*</em></a>
                                            </li><!-- 활성화된 탭에 on class -->
                                            <li :class="(processStep === 2) ? 'on' : ''">
                                                <a href="javascript:" :title="$t('FIELD.GLOBAL.MODEL.LIST')">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}<em class="ico_info"><i class="tooltip">{{ $t('MESSAGE.KNOWLEDGE.MODELLIST.TOOLTIP') }}</i></em></a>
                                            </li>
                                            <li :class="(processStep === 3) ? 'on' : ''">
                                                <a href="javascript:" :title="$t('FIELD.KNOWLEDGE.PARTSLISTS')">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}<em class="txt_mandatory" v-if="showSerial" >*</em> <em class="ico_info"><i class="tooltip">{{ $t('MESSAGE.KNOWLEDGE.PARTSLIST.TOOLTIP') }}</i></em></a>
                                            </li>
                                            <li :class="(processStep === 4) ? 'on' : ''">
                                                <a href="javascript:" :title="$t('FIELD.KNOWLEDGE.VERHISTORY')">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}<em class="txt_mandatory">*</em></a>
                                            </li>
                                        </ul>
                                        <div class="tab_contents">
                                            <!-- Description tab -->
                                            <div class="tab_cont" :class="(processStep === 1) ? 'on' : ''">
                                                <div v-if="getIsModify || isServiceScript" class="in_btn">
                                                    <a href="javascript:" class="btn_templete" :title="$t('FIELD.KNOWLEDGE.TEMPLATE')" @click="templatePop">{{ $t('FIELD.KNOWLEDGE.TEMPLATE') }}</a>
                                                    <a href="javascript:" class="btn_templete" :title="$t('FIELD.GLOBAL.TRANSLATION')" @click="translationPop">{{ $t('FIELD.GLOBAL.TRANSLATION') }}</a>
                                                    <a href="javascript:" class="btn_templete" :title="$t('FIELD.KNOWLEDGE.IMAGECLOUD')" @click="imageCloudPop">{{ $t('FIELD.KNOWLEDGE.IMAGECLOUD') }}</a>
                                                </div>

                                                <fragment v-if="getIsModify || isServiceScript">
                                                    <cross-editor
                                                        v-if="isImportNamo && !isLoading"
                                                        :editorId="getEditorId"
                                                        :editorData="KNOWLEDGE_DESC || getServiceBulletinTemplate"
                                                    />

                                                    <div class="btn_wrap text_right pt-10">
                                                        <a href="javascript:" class="txt_link" :title="$t('BUTTON.KNOWLEDGE.DELETE.TEMPLATE')" @click="resetTemplate">{{ $t('BUTTON.KNOWLEDGE.DELETE.TEMPLATE') }}</a>
                                                    </div>
                                                </fragment>

                                                <fragment v-else>
                                                    <cross-editor-viewer
                                                        v-if="isImportNamo && !isLoading"
                                                        :editorId="getViewerId"
                                                        :editorData="KNOWLEDGE_DESC || getServiceBulletinTemplate"
                                                    />
                                                </fragment>
                                            </div>
                                            <!-- Model List tab -->
                                            <div class="tab_cont" :class="(processStep === 2) ? 'on' : ''">
                                                <!-- Grid -->
                                                <div class="grid_wrap" v-resize="setGridResizeColumn(processStep)">
                                                    <div v-if="getIsModify || isServiceScript" class="grid_top">
                                                        <fieldset class="ui_fieldset">
                                                            <label class="serach-wrap">
                                                                <input type="text" class="text_input" v-model="searchModel" :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH')" @keyup.enter.stop="modelSearchPop">
                                                                <a href="javascript:" class="in_btn_search" :title="$t('FIELD.GLOBAL.SEARCH')" @click="modelSearchPop">
                                                                    <i class="ico_input_serach"></i>
                                                                    <span class="sr_only">{{ $t('FIELD.GLOBAL.SEARCH') }}</span>
                                                                </a>
                                                            </label>
                                                        </fieldset>
                                                        <div class="btn_wrap">
                                                            <a href="javascript:" class="btn_sm_white" :title="$t('BUTTON.GLOBAL.SAMPLE.DOWNLOAD')" @click="downloadWithAxios('model')">{{ $t('BUTTON.GLOBAL.SAMPLE.DOWNLOAD') }}</a>
                                                            <span class="btn_filebox btn_sm_white">
                                                                <label for="model_file_id">{{ $t('BUTTON.GLOBAL.FILE.UPLOAD') }}</label>
                                                                <input
                                                                    type="file"
                                                                    id="model_file_id"
                                                                    ref="model_file_ref"
                                                                    @change="modelUpload($event)"
                                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                                />
                                                            </span>
                                                            <a href="javascript:" class="btn_sm_white" :class="isModelValidation ? '': 'disabled'" :title="$t('BUTTON.KNOWLEDGE.MODEL.VALIDATION')" @click="modelValidation">{{ $t('BUTTON.KNOWLEDGE.MODEL.VALIDATION') }}</a>
                                                            <a href="javascript:" class="btn_sm_white" :title="$t('BUTTON.GLOBAL.DELETEALL')" @click="modelAllDelete">{{ $t('BUTTON.GLOBAL.DELETEALL') }}</a>
                                                        </div>
                                                    </div>
                                                    <model-grid
                                                        v-if="processStep === 2"
                                                        :gridId="getMdlGridId"
                                                        :ref="getMdlGridId"
                                                        :columns="modelColumns"
                                                        :data="modelList"
                                                        :options="options"
                                                        :pageOptions="pageOptions"
                                                        :isTotalCount="false"
                                                        :click="modelColumnClick"
                                                    />

                                                    <div class="page_wrap top20">
                                                        <div class="grid_total">
                                                            <em>{{ modelList.length | numberFormat }}</em> {{ $t('FIELD.GLOBAL.MODEL') }}<template v-if="modelList.length > 1">s</template>
                                                            <span v-if="showFailCnt" class="fail">
                                                                (
                                                                    {{ $t('FIELD.KNOWLEDGE.MODEL.FAIL') }} : {{ validFailCnt | numberFormat }}
                                                                    <em class="ico_info"><i class="tooltip">{{ $t('MESSAGE.KNOWLEDGE.MODEL.VALIDATION.TOOLTIP') }}</i></em>
                                                                )
                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <!-- Parts List tab -->
                                            <div class="tab_cont" :class="(processStep === 3) ? 'on' : ''">
                                                <!-- Grid -->
                                                <div class="grid_wrap" v-resize="setGridResizeColumn(processStep)">
                                                    <div v-if="getIsModify || isServiceScript" class="grid_top">
                                                        <div class="btn_wrap">
<!--                                                             <a href="javascript:" class="btn_sm_white" :title="$t('BUTTON.GLOBAL.SAMPLE.DOWNLOAD')" @click="downloadWithAxios('parts')">{{ $t('BUTTON.GLOBAL.SAMPLE.DOWNLOAD') }}</a>200616수정 - 하단버튼을 위치이동 -->
                                                            <a href="javascript:" class="btn_sm_white" :title="$t('BUTTON.GLOBAL.SAMPLE.DOWNLOAD')" @click="sampleExcelDownload()">{{ $t('BUTTON.GLOBAL.SAMPLE.DOWNLOAD') }}</a><!-- 200616수정 - 하단버튼을 위치이동 -->
                                                            <span class="btn_filebox btn_sm_white" >
                                                                <label for="parts_file_id">{{ $t('BUTTON.GLOBAL.FILE.UPLOAD') }}</label>
                                                                <input
                                                                    type="file"
                                                                    id="parts_file_id"
                                                                    ref="parts_file_ref"
                                                                    @change="partsUpload($event)"
                                                                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                                />
                                                            </span>
                                                            <a href="javascript:" class="btn_sm_white" :title="$t('BUTTON.GLOBAL.DELETEALL')" @click="partsAllDelete">{{ $t('BUTTON.GLOBAL.DELETEALL') }}</a>
                                                        </div>
                                                    </div>

                                                    <parts-grid
                                                        v-if="processStep === 3"
                                                        :gridId="getPtsGridId"
                                                        :ref="getPtsGridId"
                                                        :columns="partsColumns"
                                                        :data="partsList"
                                                        :options="options"
                                                        :pageOptions="pageOptions"
                                                        :isTotalCount="false"
                                                    />
                                                </div>
                                                <!-- //Grid -->
                                            </div>
                                            <!-- Version history tab -->
                                            <div class="tab_cont" :class="(processStep === 4) ? 'on' : ''">
                                                <table class="data_table">
                                                    <colgroup>
                                                        <col width="15%">
                                                        <col width="15%" class="pc_only">
                                                        <col width="25%" class="pc_only">
                                                        <col width="*">
                                                    </colgroup>
                                                    <thead>
                                                        <tr class="text_center">
                                                            <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                                            <th class="pc_only">{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                                            <th class="pc_only">{{ $t('FIELD.GLOBAL.EDITOR') }}</th>
                                                            <th>{{ $t('FIELD.GLOBAL.DETAILS') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="text_center">
                                                        <!-- 첫번째 버전 입력창이 뜨는 조건 : 읽어온 버전 목록이 없거나, 혹은 1개 이면서 MORF_REASON 이 없고 상태코드가 P 이거나 없는 것 -->
                                                        <tr v-if="versionList.length === 0 || versionList.length === 1 && typeof versionList[0].MODF_REASON === 'undefined' && (STATUS === 'P' || STATUS === '')">
                                                            <td>Ver.1</td>
                                                            <td class="pc_only">{{ getEditDate }}</td>
                                                            <td class="pc_only">{{ getEditor }}</td>
                                                            <td class="text_left">
                                                                <span class="clearable">
                                                                    <input
                                                                        id="MODF_REASON"
                                                                        type="text"
                                                                        class="text_input w100p"
                                                                        v-model.trim="versionDesc"
                                                                        :placeholder="$t('FIELD.KNOWLEDGE.VERSION.PLACEHOLDER')"
                                                                        :title="$t('BUTTON.GLOBAL.DELETE')"
                                                                        v-validation="{ groupId: 'description' }"
                                                                        :errorMessage="'MESSAGE.GLOBAL.VERIFICATION'"
                                                                    >
                                                                    <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <fragment v-else>
                                                            <tr v-if="getIsModify || isServiceScript">
                                                                <td>Ver.{{ versionList.length + 1 }}</td>
                                                                <td class="pc_only">{{ getEditDate }}</td>
                                                                <td class="pc_only">{{ getEditor }}</td>
                                                                <td class="text_left">
                                                                    <span class="clearable">
                                                                        <input
                                                                            id="MODF_REASON"
                                                                            type="text"
                                                                            class="text_input w100p"
                                                                            v-model.trim="versionDesc"
                                                                            :placeholder="$t('FIELD.KNOWLEDGE.VERSION.PLACEHOLDER')"
                                                                            :title="$t('BUTTON.GLOBAL.DELETE')"
                                                                            v-validation="{ groupId: 'description' }"
                                                                            :errorMessage="'MESSAGE.GLOBAL.VERIFICATION'"
                                                                        >
                                                                        <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr v-for="(version, idx) in versionList">
                                                                <td>Ver.{{ version.VERSION_NO }}</td>
                                                                <td class="pc_only">{{ version.MODF_DT }}</td>
                                                                <td class="pc_only">{{ version.MODF_USER }}</td>
                                                                <td class="text_left">
                                                                    <a  v-if="idx > 0"
                                                                        href="javascript:"
                                                                        class="over_line"
                                                                        @click="seeDetailPop(version.KNOWLEDGE_ID, version.VERSION_NO)"
                                                                    >
                                                                        {{ version.MODF_REASON }}
                                                                    </a>
                                                                    <template v-else>{{ version.MODF_REASON }}</template>
                                                                    <a  v-if="typeof(version.APPROVAL_ID) !== 'undefined'"
                                                                        href="javascript:"
                                                                        class="txt_link"
                                                                        @click="seeApprovalHistoryPop(version.APPROVAL_ID)"
                                                                    >
                                                                        {{ $t('FIELD.GLOBAL.ETC.001') }}
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </fragment>
                                                    </tbody>
                                                </table>

                                                <div v-if="isPrevious" class="btn_wrap text_right pt-10">
                                                    <a href="javascript:" class="txt_link" :title="$t('FIELD.KNOWLEDGE.SEE.PREVIOUS')" @click="seePrevPop">{{ $t('FIELD.KNOWLEDGE.SEE.PREVIOUS') }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="noLine"><!-- 200708수정 - 클래스추가 -->
                                <th>{{ $t('FIELD.GLOBAL.ATTACHMENT') }}</th>
                                <td colspan="5" class="no_padding">
                                    <innorix-upload
                                        v-if="!isLoading"
                                        :id="getUploadId"
                                        :name="getUploadId"
                                        :uploadId="getUploadId"
                                        :onlyUpload="onlyUpload"
                                        :attachList="attachFileSeq"
                                        :buttonDisable="(!getIsModify)"
                                        :isSCMSDirect="isSCMSDirect"
                                        @files="setAttachFiles"
                                    />
                                </td>
                            </tr>
                        </table>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap_full topLine">
                        <!-- 뒤로가기 버튼은 첫번째 단계에서는 나오지 않는다. ( v-if="prcessStep > 1" ) -->
                        <a v-if="processStep > 1" href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.PREVIOUS')" @click="btnPrevious">{{ $t('BUTTON.GLOBAL.PREVIOUS') }}</a>
                        <div class="btn_right" v-if="isAdminMenu">
                            <!--
                                # Expired, Expiring, Trash Menu Button 표시 조건
                                # Admin Menu 여부와 버튼 권한은 공통으로 들어간다. (isAdminMenu && adminButtonAuth)
                                Previous        : processStep > 1
                                Recover         : (adminMenuType === 'EPD' && STATUS === 'E' || adminMenuType === 'TRS' && STATUS === 'T')
                                Trash           : adminMenuType === 'EPD' && STATUS === 'E'
                                Extended Period : adminMenuType === 'EXP' && STATUS === 'S'
                                Remove          : adminMenuType === 'TRS' && STATUS === 'T'
                                Next            : processStep < 4
                            -->
                            <a v-if="isAdminMenu && adminButtonAuth && (adminMenuType === 'EPD' && STATUS === 'E' || adminMenuType === 'TRS' && STATUS === 'T')" href="javascript:" class="btn_white" @click="btnRecover">{{ $t('BUTTON.GLOBAL.RECOVER') }}</a>
                            <a v-if="isAdminMenu && adminButtonAuth && adminMenuType === 'EPD' && STATUS === 'E'" href="javascript:" class="btn_white" @click="btnTrash">{{ $t('BUTTON.GLOBAL.TRASH') }}</a>
                            <a v-if="isAdminMenu && adminButtonAuth && adminMenuType === 'EXP' && STATUS === 'S'" href="javascript:" class="btn_white" @click="btnExtendPeriod">{{ $t('BUTTON.GLOBAL.EXTEND.PERIOD') }}</a>
                            <a v-if="isAdminMenu && adminButtonAuth && adminMenuType === 'TRS' && STATUS === 'T'" href="javascript:" class="btn_white" @click="btnRemove">{{ $t('BUTTON.GLOBAL.REMOVE') }}</a>
                            <a v-if="processStep < 4" href="javascript:" class="btn_blue" :title="$t('BUTTON.GLOBAL.NEXT')" @click="btnNext">{{ $t('BUTTON.GLOBAL.NEXT') }}</a>

                        </div>
                        <div class="btn_right" v-else-if="isServiceScript">
                            <!--
                                # Service script only
                                Previous    : processStep > 1
                                Save        : processStep > 3
                                Next        : processStep < 4
                            -->
                            <a v-if="processStep > 3" href="javascript:" class="btn_blue" @click="btnAddContentsSave">{{ $t('BUTTON.GLOBAL.SAVE') }}</a>
                            <a v-if="processStep < 4" href="javascript:" class="btn_blue" :title="$t('BUTTON.GLOBAL.NEXT')" @click="btnNext">{{ $t('BUTTON.GLOBAL.NEXT') }}</a>

                        </div>
                        <div class="btn_right" v-else-if="isSCMSDirect">
                            <!--
                                # Only view
                                Previous    : processStep > 1
                                /* Save draft  : (STATUS === '' || STATUS === 'P') && processStep < 4 */
                                Modify      : STATUS === 'S' && !getIsModify
                                Register    : processStep > 3 && getIsModify
                                Next        : processStep < 4
                            -->
                            <!-- <a v-if="(STATUS === '' || STATUS === 'P') && processStep < 4" href="javascript:" class="btn_white" @click="btnSaveDraft">{{ $t('BUTTON.GLOBAL.SAVEDRAFT') }}</a> -->
                            <a v-if="(STATUS === 'S' || STATUS === 'C') && !getIsModify" href="javascript:" class="btn_white" @click="btnModify">{{ $t('BUTTON.GLOBAL.EDIT') }}</a>
                            <a v-if="processStep > 3 && getIsModify" href="javascript:" class="btn_blue" @click="btnRegister">{{ $t('BUTTON.GLOBAL.REGISTER') }}</a>
                            <a v-if="processStep < 4" href="javascript:" class="btn_blue" :title="$t('BUTTON.GLOBAL.NEXT')" @click="btnNext">{{ $t('BUTTON.GLOBAL.NEXT') }}</a>

                        </div>
                        <div class="btn_right" v-else-if="isOnlyView">
                            <!--
                                # Only view
                                Previous    : processStep > 1
                                Next        : processStep < 4
                            -->
                            <a v-if="processStep < 4" href="javascript:" class="btn_blue" :title="$t('BUTTON.GLOBAL.NEXT')" @click="btnNext">{{ $t('BUTTON.GLOBAL.NEXT') }}</a>

                        </div>
                        <div class="btn_right" v-else>
                            <!--
                                # Button 표시 조건
                                # getIsModify 는 별도 함수 참조
                                Delete      : KNOWLEDGE_ID.length && Status = 'P'
                                Previous    : processStep > 1
                                Preview     : processStep === 1 && getIsModify
                                Save draft  : (STATUS === '' || STATUS === 'P') && processStep < 4
                                Register    : processStep > 3 && getIsModify
                                Modify      : STATUS === 'S' && !getIsModify
                                Expire      : STATUS === 'S' && !getIsModify
                                Next        : processStep < 4
                            -->
                            <a v-if="KNOWLEDGE_ID.length && STATUS === 'P' " href="javascript:" class="btn_white" @click="btnDelete">{{ $t('BUTTON.GLOBAL.DELETE') }}</a>
                            <a v-if="KNOWLEDGE_ID.length && STATUS === 'C' && IfFirstApproval" href="javascript:" class="btn_white" @click="btnDelete">{{ $t('BUTTON.GLOBAL.DELETE') }}</a>
                            <a v-if="processStep === 1 && getIsModify" href="javascript:" class="btn_white" @click="btnPreview">{{ $t('BUTTON.NOTICE.PREVIEW') }}</a>
                            <a v-if="(STATUS === '' || STATUS === 'P') && processStep < 4" href="javascript:" class="btn_white" @click="btnSaveDraft">{{ $t('BUTTON.GLOBAL.SAVEDRAFT') }}</a>
                            <a v-if="processStep > 3 && getIsModify" href="javascript:" class="btn_blue" @click="btnRegister">{{ $t('BUTTON.GLOBAL.REGISTER') }}</a>
                            <a v-if="(STATUS === 'S' || STATUS === 'C') && !getIsModify" href="javascript:" class="btn_white" @click="btnModify">{{ $t('BUTTON.GLOBAL.EDIT') }}</a>
                            <a v-if="STATUS === 'S' && !getIsModify" href="javascript:" class="btn_white" @click="btnExpire">{{ $t('BUTTON.GLOBAL.EXPIRE') }}</a>
                            <a v-if="processStep < 4" href="javascript:" class="btn_blue" @click="btnNext">{{ $t('BUTTON.GLOBAL.NEXT') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import resize                               from 'vue-resize-directive'
import api                                  from '@/service';
import store                                from '@/vuex/store';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';
import ToastGrid                            from '~c/ToastGrid';
import CrossEditor                          from '~c/CrossEditor';
import CrossEditorViewer                    from '~c/CrossEditorViewer';
import InnorixUpload                        from '~c/InnorixUpload';
import ImageCloudListPopup                  from '~va/tool/imageCloudListPopup';
import KnowledgeModelGrid                   from './KnowledgeModelGrid';
import KnowledgePartsGrid                   from './KnowledgePartsGrid';
import refTitleFilter                       from '@/filters/refTitle';
import KnowledgePreviewPopup                from '~c/popup/KnowledgePreviewPopup';
import TransPopup                           from '~c/popup/TransPopup';
import ApprovalPopup                        from '~c/popup/ApprovalPopup';
import ApprovalHistoryPopup                 from '~c/popup/ApprovalHistoryPopup';
import KnowledgeModelPopup                  from './KnowledgeModelPopup';
import KnowledgeTemplatePopup               from './KnowledgeTemplatePopup';
import KnowledgeTargetPopup                 from './KnowledgeTargetPopup';
import KnowledgePreviousPopup               from './KnowledgePreviousPopup';
import KnowledgeVersionDetailPopup          from './KnowledgeVersionDetailPopup';
import ExtendedPeriodPopup                  from '~va/knowledgeManager/expiringKnowledge/popup/ExtendedPeriodPopup';

// CrossEditor default blank page
//import ServiceBulletinTemp                  from '/static/sample/CREATE_Template_01.html';
import ServiceBulletinTemp                  from '/static/sample/CREATE_Template_02.html';
//import RepairTipTemp                        from '/static/sample/CREATE_Template_02.html';
import CallGuideTemp                        from '/static/sample/CREATE_Template_03.html';
import BlankTemp                            from '/static/sample/CREATE_Template_04.html';
import ExcelDownloadPopup 					from '~vb/common/ExcelDownloadPopup';

// java to moment dateformat parser
require('moment-jdateformatparser');

const MAX_DATE = new Date(2999,12,31),
      MIN_DATE = new Date(1900,1,1);

// Service Bulletin, Repair Tip, Repeated Repair Tip
const SCMS_CONTENTS_CD = MenuUtil.getScmsContents;
const REPAIR_MENU = MenuUtil.getRepairMenuGroup;

const fetchCodeCombo = (codeCategoryId, categoryId, symptomType = '', symptom1 = '') => axios.get(
    `${SDLUtil.API_URL}/basis/common/codeAjax.skp?`
  + `codeCategoryId=${codeCategoryId}`
  + `&categoryId=${categoryId}`
  + `&symptomType=${symptomType}`
  + `&symptom1=${symptom1}`
  + `&parentCode=1`
);

// get Board Infomation
const fetchBoardInfo = boardTypeForm => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/findBoardInfoByBoardType.skp`,
    qs.stringify(boardTypeForm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// Knowledge Detail
const fetchKnowledgeDetail = knowledgeId => axios.post(
    `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/registerDetail.skp`,
    qs.stringify({ KNOWLEDGE_ID: knowledgeId }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// ServiceScript Detail
const fetchServiceScript = (knowledgeId, serviceScriptId, reProcessCorpNo) => axios.post(
    `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/addContents.skp`,
    qs.stringify({ KNOWLEDGE_ID: knowledgeId, SERVICE_SCRIPT_ID: serviceScriptId, RE_PROCESS_CORP_NO: reProcessCorpNo }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// Knowledge saveDraft api
const fetchSaveDraft = regForm => {
    // knowledgeId가 없는 경우 최초 생성 (KnowledgeId) -> 이후 업데이트
    let api = `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/registerSaveDraft.skp`;
    if(!StringUtil.isNull(regForm.KNOWLEDGE_ID)) {
        api = `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/updateDraft.skp`;
    }

    return axios.post( api, qs.stringify(regForm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } );
};

// Knowledge register
const fetchRegisterSave = regForm => axios.post(
    `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/updateFormally.skp`,
    qs.stringify(regForm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

const delIcon = '/static/images/ico_delete.png';

// ToastGrid image icon renderer
class CustomDeleteRenderer {
    constructor(props) {
        const el    = document.createElement('a'); el.className = 'ico_delete';
        const span  = document.createElement('span'); span.className = 'sr_only';
        span.appendChild(document.createTextNode(SDLUtil.getMsgProp('BUTTON.GLOBAL.DELETE')));

        el.appendChild(span);
        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

// ToastGrid subject renderer
class CustomTitleRenderer {
    constructor(props) {
        const el = document.createElement('div');
        el.className = "tui-grid-cell-content";

        const em = document.createElement('em'),
              imEm = document.createElement('em');

        let title = props.value || 'Untitled';

        // Read, Hot, New, Update
        if(title.indexOf('@R@') > -1) {
            em.className = "textbgbox_recommend";
            em.innerText = "R";
            title = title.replace('@R@', '');
            el.appendChild(em);

        } else if(title.indexOf('@H@') > -1){
            em.className = "textbgbox_hot";
            em.innerText = "H";
            title = title.replace('@H@', '');
            el.appendChild(em);

        } else if(title.indexOf('@N@') > -1){
            em.className = "textbgbox_new";
            em.innerText = "N";
            title = title.replace('@N@', '');
            el.appendChild(em);

        } else if(title.indexOf('@U@') > -1){
            em.className = "textbgbox_update";
            em.innerText = "U";
            title = title.replace('@U@', '');
            el.appendChild(em);
        }

        // Important, Must Read
        if(title.indexOf('@I@') > -1) {
            imEm.className = "textcolor_important";
            imEm.innerText = "["+ SDLUtil.getMsgProp('FIELD.GLOBAL.IMPORTANT') +"]";
            title = title.replace('@I@', '');
            title = title.replace('@M@', '');   // Important, Must Read 중복 방지
            el.appendChild(imEm);

        } else if(title.indexOf('@M@') > -1) {
            imEm.className = "textcolor_must";
            imEm.innerText = "["+ SDLUtil.getMsgProp('FIELD.GLOBAL.MUSTREAD') +"]";
            title = title.replace('@M@', '');
            el.appendChild(imEm);
        }

        title = SDLUtil.convertHtml(title);
        el.appendChild(document.createTextNode(title));

        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

export default {
    name: 'KnowledgeContentsPopup',
    props: {
        title:              {},
        boardId:            {},
        knowledgeId:        {},
        serviceScriptId:    {},
        boardType1:         {},
        boardType2:         {},
        rtnFunc:            { type: Function },
        isPopupClose:       { default: false },
        isVdOrDa:           { default: false }, // TV VIDEO & AUDIO => VD  or  Home appliances => DA
        isModify:           { default: false }, // 수정 모드
        isOnlyView:         { default: false }, // 보기 모드
        isSCMSDirect:       { default: false }, // SCMS Direct Access
        cttType:            {},                 // SCMS 에서 선택된 cttType
        scmsModelCd:        {},                 // SCMS 에서 선택된 Model code
        scmsModelGbmCd:     {},                 // SCMS 에서 선택된 Model code의 GBM 코드 // TODO
        scmsEcnNo:          {},                 // SCMS 에서 넘어온 ECN_NO
        scmsCategoryCd1:    { default: '' },    // SCMS 에서 넘어온 카테고리 코드1
        scmsCategoryCd2:    { default: '' },    // SCMS 에서 넘어온 카테고리 코드2
        scmsCategoryCd3:    { default: '' },    // SCMS 에서 넘어온 카테고리 코드3
        isBugReport:        { default: false }, // 버그 리포트
        bugReportId:        {},
        isAdminMenu:        { default: false }, // 관리자 메뉴에서 접근
        adminButtonAuth:    { default: false }, // 관리자 메뉴 버튼 권한
        adminMenuType:      {},                 // 관리자 메뉴 유형 (EPD: Expired, EXP: Expiring, TRS: Trash)
        isServiceScript:    { default: false }, // ServiceScript
        serviceScriptType:  {},                 // ServiceScript 유형 (HQ: Reprocess, RE: Recommendation)
        shareId:            {},                 // Request Sharing ID
        isRequestSharing:   { default: false }, // Request Sharing
        requesterId:        {},                 // Request Sharing Requester Id
        reProcessCorpNo:    { default: '' },    // reProcess 조회조건

    },
    data() {
        return {
        	rtAndSb : false,			// Service Bulletin and RepairTip display the required icon
            isLoading : false,          // Loading 완료 체크
            isImportNamo: false,        // Namo Editor import check

            isBoardAccess: false,       // 각 게시판에서 호출했을 때, 혹은 SCMS에서 cttType 지정해서 왔을 때

            guid: '',                   // 임의의 guid
            editorId: '',               // CrossEditor id
            viewerId: '',               // CrossEditor Viewer Id
            uploadId: '',               // Innorix id
            onlyUpload: false,          // Innorix upload only check
            isRepair: false,            // Repair tip 메뉴 체크
            isSCMSContents: true,       // SCMS Contents 체크
            isRhq: false,               // RHQ 체크 -> 권한 확인을 어떤 기준으로 하는지?
            targetAllPass: false,       // Distribute target
            verifyUseYn: false,         // 결재/검증 여부

            // SaveDraft 이후 knowledgeId 리턴
            KNOWLEDGE_ID: '',           // KnowledgeId
            STATUS: '',                 // Knowledge Status -> Knowledge Detail 읽어온 후
            STATUS_NAME: '',            // Knowledge Status name

            SERVICE_SCRIPT_ID: '',      // Reprocess 용 ServiceScriptId
            OLD_KNOWLEDGE_ID: '',       // Reprocess 용 Old KnowledgeId

            CTTID: '',                  // SCMS Direct 전용 CTTID -> 컨텐츠 생성 후 리턴용

            // Contents 작성 진행 상태
            processStep: 1,             // 진행 상태 (Step 1 ~ 4)
            isProcess: false,           // 진행 여부

            BOARD_TYPE1: '',            // board Type - board parent id
            BOARD_TYPE2: '',            // board Type - board id
            boardType1List: [],         // board Type List 1
            boardType2List: [],         // board Type List 2
            boardInfo: {},              // Board information

            PRD_CATEGORY_CD1: '',       // Category 1
            PRD_CATEGORY_CD2: '',       // Category 2
            PRD_CATEGORY_CD3: '',       // Category 3
            categoryComboList1: [],     // Category 1 List
            categoryComboList2: [],     // Category 2 List
            categoryComboList3: [],     // Category 3 List

            symptomList: [{
                SYMPTOM_TYPE: '',       // Symptom 1
                SYMPTOM_TYPE1: '',      // Symptom 2
                SYMPTOM_TYPE_CODE: '',  // Symptom type code
                SYMPTOM_TYPEList: [],   // Symptom 1 List
                SYMPTOM_TYPE1List: [],  // Symptom 2 List
            }],
            oldSymptomList: [],         // Old Symptom List

            GBM_CD: '',                 // GBM Code
            KNOWLEDGE_TITLE: '',        // Knowledge title
            KNOWLEDGE_DESC: '',         // Knowledge description
            DIST_TARGET: 'S',           // Target type (S : subsidiary, G : global)
            selectSubsidiary: [],       // Target global subsidiary
            oldSelectSubsidiary: [],

            isAllowSharing: true,       // Allow sharing
            isExternalSharing: true,       // External sharing

            importantYn: false,         // Important check
            mustreadYn: false,          // Must read check

            MANF_FROM_DATE: null,       // Manufacture From date
            MANF_TO_DATE: null,         // Manufacture To date
            MANF_RANGE_DATE: null,      // Manufacture from-to range

            serialList: [
                { SERIAL_S: '', SERIAL_E: '' }
            ],                          // Serial Number List
            oldSerialList: [],          // Old Serial Number List

            defectType: '',             // Defect Type
            guideType: '',              // Guide Type1

            searchModel: '',            // Search model code
            modelList: [],              // Model List
            oldModelList: [],           // Old Model List
            scmsFixModel: {},           // SCMS Fix Model Object
            isModelValidation: false,   // Model excel update Y/N
            validFailCnt: 0,            // Model excel fail count
            showFailCnt: false,         // Show fail count

            partsList: [],              // Parts List
            oldPartsList: [],           // Old Parts List
            versionList: [],            // Version List
            versionDesc: '',            // Version description
            isPrevious: false,          // 이전 컨텐츠 여부

            attachFileSeq: [],          // Attach files
            oldAttachFileSeq: [],       // Old Attach files
            delAttachFiles: [],         // Delete attach files
            isRemove: false,            // Attach remove flag
            isUserModify: false,        // User modify

            knowledgeDetail: {},        // Knowledge contents detail

            scmsYn: false,

            // Model tab grid column
            modelGridId: '',
            modelColumns: [],

            // Parts tab grid column
            partsGridId: '',
            partsColumns: [],

            // Toast Grid 에서 공용으로 사용할 parameter
            options:        { scrollX: false, scrollY: true, minBodyHeight: 80, bodyHeight: 265, rowHeight: 48 },
            pageOptions:    { useClient: true, perPage: 20 },

            reProcessMenuDetailCd: '',
            isReadOnly: false,       // Must Read readonly
            DETAIL_MODF_DT:'',
            DETAIL_REG_DT:'',
            IfFirstApproval:'',
        }
    },
    directives: { resize },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
            connSystem: 'getConnSystem',
        }),
        getTitle()          { return StringUtil.nvl(this.title, 'myKnowledge'); },
        getGuid()           { if(StringUtil.isNull(this.guid)) { this.guid = StringUtil.guid() } return this.guid; },
        getEditorId()       { if(StringUtil.isNull(this.editorId)) { this.editorId = 'ce_'+this.getGuid; } return this.editorId; },
        getViewerId()       { if(StringUtil.isNull(this.viewerId)) { this.viewerId = 'vw_'+this.getGuid; } return this.viewerId; },
        getUploadId()       { if(StringUtil.isNull(this.uploadId)) { this.uploadId = 'inno_'+this.getGuid; } return this.uploadId; },
        getMdlGridId()      { if(StringUtil.isNull(this.modelGridId)) { this.modelGridId = 'mdl'+this.getGuid; } return this.modelGridId; },
        getPtsGridId()      { if(StringUtil.isNull(this.partsGridId)) { this.partsGridId = 'pts'+this.getGuid; } return this.partsGridId; },
        getUserInfo()       { return SDLUtil.getLoginedUserInfo() || {}; },
        getUserRole()       { return this.userRoles || []; },
        getUserCorpCd()     { return StringUtil.nvl(this.reProcessCorpNo, this.userCorpCd) || ''; },
        getScrapWorkCode()  { return MenuUtil.getScrapWorkCode(); },
        getSelBoardType1()  { return this.boardType1 || this.BOARD_TYPE1 || ''; },  // prop 에서 넘어온 boardType이 우선
        getSelBoardType2()  { return this.boardType2 || this.BOARD_TYPE2 || ''; },  // prop 에서 넘어온 boardType이 우선
        getBoardId()        { return this.boardId || this.boardInfo.BOARD_ID || ''; },
        getSelCategory1()   { return StringUtil.isNull(this.scmsCategoryCd1) ? this.PRD_CATEGORY_CD1 : this.scmsCategoryCd1 },
        getSelCategory2()   { return StringUtil.isNull(this.scmsCategoryCd2) ? this.PRD_CATEGORY_CD2 : this.scmsCategoryCd2 },
        getSelCategory3()   { return StringUtil.isNull(this.scmsCategoryCd3) ? this.PRD_CATEGORY_CD3 : this.scmsCategoryCd3 },
        getGBMCode()        { return this.GBM_CD || (this.modelList.length ? this.modelList[0].CDGBM : ''); },
        getBoardAccess()    { // Knowledge board menu에서 접근하였는지 확인
            if(!StringUtil.isNull(this.boardType1) && !StringUtil.isNull(this.boardType2)) {
                return true;

            } else {
                return false;
            }
        },
        getMenuGrpCd()      { // 메뉴 그룹 코드
            if(this.isSCMSDirect) {
                return this.cttType;

            } else if(this.getBoardAccess) {
                return StringUtil.nvl(this.params.menuGrpDetailCd, '');

            } else if(!StringUtil.isNull(this.reProcessCorpNo)) {
                return StringUtil.nvl(this.reProcessMenuDetailCd, '');

            } else if(!StringUtil.isNull(this.getSelBoardType2)) {
                let currentMenu = _.find(MenuUtil.menuScan(this.getSelBoardType2, this.menus), function(m) { return m.currMenu === true });
                return StringUtil.nvl(currentMenu.menuGrpDetailCd, '');

            } else {
                return '';
            }
        },
       //Get userCorpCdCode , if 'C820','C390' can use external sharing function. ke01.liu 2022-07-22
        getUserCorpCode(){
        	let userCorpCode = this.userCorpCd  || '';
        	if(['C820','C390'].includes(userCorpCode)){
                 return true;
            } else {
                 return false;
            }
        },
        // Get MenuGrpDetailCode , if ['KSML','KRTT','KSBL','TM'] can use external sharing function. ke01.liu 2022-07-22
        getMenuGrpDetailCd() {
        	let menuGrpDetailCd = this.params.menuGrpDetailCd  || '';
        	if(['KSML','KRTT','KSBL','TM'].includes(menuGrpDetailCd)){
                 return true;
            } else {
                 return false;
            }
        },


        // Get MenuGrpDetailCode . ke01.liu 2024-11-20  IF local sevice Bulletin ...
        getMenuCdLocalSbYn() {
        	if('KSBL' === this.params.menuGrpDetailCd || this.cttType === 'KSBL' || this.MENU_GROUP_DETAIL_CD === 'KSBL' ){
        		return true;
        	}else{
        		return false;
        	}
        },
        // Get MenuGrpDetailCode . ke01.liu 2023-01-23  IF sevice Bulletin email...
        getMenuCdSbYn() {
        	if('SB' === this.params.menuGrpDetailCd || this.cttType === 'SB' || this.MENU_GROUP_DETAIL_CD === 'SB'){
        		return true;
        	}else{
        		return false;
        	}
        },
        // get Gudie Type Verify Use Yn
        getGudieTypeVerifyUseYn(){
        	if(this.PRD_CATEGORY_CD1 === 'A' || this.PRD_CATEGORY_CD1 === 'C'){
        		return true;
        	} else {
        		return false;
        	}
        },
        // if Must-Read display show Serial Number  ke01.liu 20241106
        showSerial(){
            if(('SB' === this.params.menuGrpDetailCd || this.cttType === 'SB' || this.MENU_GROUP_DETAIL_CD === 'SB' || 'KSBL' === this.params.menuGrpDetailCd || this.cttType === 'KSBL' || this.MENU_GROUP_DETAIL_CD === 'KSBL') && (this.PRD_CATEGORY_CD1 === 'A' || this.PRD_CATEGORY_CD1 === 'C') && this.mustreadYn){
        		return true;
        	}else{
        		 this.serialList.splice(0,this.serialList.length);
        		 this.serialList.push({ SERIAL_S: '', SERIAL_E: '' });
        		return false;
        	}
        },

        getIsModify() {
            // 수정 여부 확인: 1. 수정여부 2. Status === 'P'
            return this.isUserModify ? this.isUserModify : (this.isModify ? this.isModify : (!this.isAdminMenu && (this.STATUS === 'P' || this.STATUS === '') ? true : false));
        },
        getBlankTemplate() {
            return BlankTemp;
        },
        getServiceBulletinTemplate() {
            return ServiceBulletinTemp;
        },
        // Version history 작성용 function : START
        getEditDate()       {
            return moment().format(localStorage.getItem('mDateFormat'));
        },
        getEditor()         {
            if(!StringUtil.isNull(this.getUserInfo)) {
                return (StringUtil.isNull(this.getUserInfo.loginName) ? this.getUserInfo.user : this.getUserInfo.loginName)
                    + " (" + (this.getUserInfo.companyName || this.getUserCorpCd) + ")";
            } else return '';
        },
        getDistributor()    {
            if(
                (this.isRhq && !this.isServiceScript)
             || (this.isRhq && !this.isServiceScript && this.isRequestSharing)
            ) {
                return true;

            } else {
                return false;
            }
        }
        // Version history 작성용 function : END
    },
    inject: {
        uploader: { from:'uploader', default:() => {} },
    },
    components: {
        'model-grid'            : KnowledgeModelGrid,
        'parts-grid'            : KnowledgePartsGrid,
        'cross-editor'          : CrossEditor,
        'cross-editor-viewer'   : CrossEditorViewer,
        'innorix-upload'        : InnorixUpload
    },
    methods: {
        // 처음 로딩 시
        initLoad() {
            // 접속자의 권한 확인, deptLevelCd 가 3이상 이거나 SCMS에서 직접 접근하는 경우
            if(
                StringUtil.nvl(this.deptLevelCd, 1) >= 3
             || this.isSCMSDirect
            ) {
                this.isRhq = true;
                if(this.isSCMSDirect) {
                    this.initLoadForSCMSDirect();
                }
            };

            // KnowledgeId 여부에 따른 이벤트 발생
            if(StringUtil.isNull(this.knowledgeId)) {
                // 게시판 타입 1 로드
                this.setBoardType1().then(() => { this.setBoardType2(); });

                // 초기 카테고리1 리스트 로드
                this.setCategory1().then(()  => { this.setCategory2().then(() => { this.setCategory3().then(); }); });

                // 생성 팝업 실행 시 넘어온 boardType1 과 boardType2의 정보가 있는 경우, Type selectbox 수정 불가
                this.isBoardAccess = this.getBoardAccess;

                this.isLoading = false;

            } else {
                // knowledgeId 가 있는 경우, detail 을 읽어와서 data에 세팅한다. => this.setDetailView(resp.data);
                this.loadKnowledgeDetail();
            };

            this.modelColumns = this.getDynamicCols('MODEL');
            this.partsColumns = this.getDynamicCols('PARTS');

            SDLUtil.showLoadingBar(false);
        },
        async initLoadForSCMSDirect() {
            const params = store.getters.getPopupParams || {};
            Vue.$log.info('▶ KnowledgeContentsPopup.vue initLoadForSCMSDirect. / cttType:', this.cttType, '/ modelCd:', this.scmsModelCd, '/ ecnNo:', this.scmsEcnNo, '/ knowledgeId:', this.knowledgeId);
            this.targetAllPass = true;

            // Target setting
            this.DIST_TARGET = 'G';
            await this.loadAllSubsidiary();

            // Model Setting
            if(!StringUtil.isNull(this.scmsModelCd) && !this.isModify) {
                this.scmsFixModel = { CDMODEL: this.scmsModelCd, NMMODEL: '', CDGBM: this.scmsModelGbmCd, FIX_MODEL: true };
                this.modelList.push(this.scmsFixModel);
            };

            // Verify
            this.verifyUseYn = true;
        },
        async loadKnowledgeDetail(rtnKnowledgeId = '') {
            // knowledgeId 가 있는 경우, detail 을 읽어와서 data에 세팅한다. => this.setDetailView(resp.data);
            this.KNOWLEDGE_ID = this.knowledgeId || rtnKnowledgeId;
            if(this.isServiceScript) {
                // Reprocess 프로세스가 시작되면 version 정보는 삭제한다.
                this.SERVICE_SCRIPT_ID = this.serviceScriptId;
                await fetchServiceScript(this.KNOWLEDGE_ID, this.SERVICE_SCRIPT_ID, this.reProcessCorpNo)
                    .then(resp => {
                        this.setDetailView(resp.data);
                        this.reProcessMenuDetailCd = resp.data.search.MENU_DETAIL_CD;
                        this.versionList = [];
                    })
                    .catch(err => {
                        this.notFoundKnowledge(err);
                    });

            } else {
                await fetchKnowledgeDetail(this.KNOWLEDGE_ID)
                    .then(resp => {
                        /*
                        // SCMS Contents 작성 후 데이터 리턴
                        if(this.isSCMSDirect) {
                            this.setRtnData(resp.data);
                        } else {
                            this.setDetailView(resp.data);
                        }
                        */
                        this.setDetailView(resp.data);
                    })
                    .catch(err => {
                        this.notFoundKnowledge(err);
                    });
            }

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        setDetailView(data) {
            /**
             * data.detail.rowData[0] : Knowledge 상세
             * data.subsidiaryList.rowData : Distribute target subsidiary
             * data.symptomList.rowData : Symptom List { SYMPTOM_TYPE: '', SYMPTOM_TYPE1: '',  SYMPTOM_TYPE_CODE: '', SYMPTOM_TYPEList: [], SYMPTOM_TYPE1List: [] }
             * data.modelList.rowData : Model List { MODEL_ID: '', MODEL_NM : '' }
             * data.serialList.rowData : Serial Number List { SERIAL_S: '', SERIAL_E: ''}
             * data.attach.rowData : Attach List
             * data.version.rowData : Version history
             * data.partsList.rowData : Parts List
             */
            Vue.$log.info('▶ KnowledgeContentsPopup.vue Set KnowledgeDetail data / knowledgeId :', this.KNOWLEDGE_ID, '/ SCMSDirect :', this.isSCMSDirect, '/ Details :', data);
            const detail                = data.detail.rowData[0];
            console.log('detail ==> ', detail);
            //ke01.liu -20241223
            this.DETAIL_MODF_DT                = detail.MODF_DT_CHECK_FIRST;
            this.DETAIL_REG_DT                 = detail.REG_DT_CHECK_FIRST;
            this.IfFirstApproval        = (this.DETAIL_MODF_DT - this.DETAIL_REG_DT) < 200 ? true : false;


            this.CTTID                  = detail.CTTID;
            this.STATUS                 = (this.serviceScriptId && this.isServiceScript) ? '' : detail.STATUS;
            this.STATUS_NAME            = detail.STATUS_NAME;
            this.BOARD_TYPE1            = detail.BOARD_TYPE1;           // detail에서 불러올때 BOARD_TYPE1 는 대메뉴
            this.BOARD_TYPE2            = detail.BOARD_TYPE2;           // detail에서 불러올때 BOARD_TYPE2 는 소메뉴
            this.MENU_GROUP_DETAIL_CD   = detail.MENU_GROUP_DETAIL_CD;
            this.PRD_CATEGORY_CD1       = detail.PRD_CATEGORY_CD1;
            this.PRD_CATEGORY_CD2       = detail.PRD_CATEGORY_CD2;
            this.PRD_CATEGORY_CD3       = detail.PRD_CATEGORY_CD3;
            this.KNOWLEDGE_TITLE        = StringUtil.decodeXSS(refTitleFilter(detail.KNOWLEDGE_TITLE));
            this.KNOWLEDGE_DESC         = detail.KNOWLEDGE_DESC;
            this.importantYn            = StringUtil.strToBool(detail.IMPORTANCE_YN);
            this.mustreadYn             = StringUtil.strToBool(detail.MUST_READ_YN);
            this.isAllowSharing         = StringUtil.strToBool(detail.ALLOW_SHARE);
            this.isExternalSharing      = StringUtil.strToBool(detail.EXTERNAL_SHARE);
            this.defectType             = detail.DEFECT_TYPE || '';
            this.guideType              = detail.GUIDE_TYPE || '';
            this.DIST_TARGET            = this.isRequestSharing ? 'G' : (detail.DIST_TARGET || 'S');    // Request sharing 조건이면 무조건 Global 로 세팅
            // Manufacture date 는 moment 를 이용하여 YYYYMM 형식으로 받는다. -> moment('202004', 'YYYYMM').toDate()
            this.MANF_FROM_DATE         = StringUtil.isNull(detail.MANUFACTURE_S_DT) ? null : moment(detail.MANUFACTURE_S_DT, 'YYYYMM').toDate();
            this.MANF_TO_DATE           = StringUtil.isNull(detail.MANUFACTURE_E_DT) ? null : moment(detail.MANUFACTURE_E_DT, 'YYYYMM').toDate();

            this.$nextTick(() => {
                this.setBoardType1().then(() => { this.setBoardType2(); });
                this.setCategory1().then(()  => { this.setCategory2().then(() => { this.setCategory3().then(); }); });
            });

            // 메뉴 그룹 상세 코드를 확인하여 Repair Menu 인 경우 증상 코드 유형 로드
            let menuGroupDetailCd = this.params.menuGrpDetailCd === 'MKR' ? this.MENU_GROUP_DETAIL_CD : this.params.menuGrpDetailCd;
                menuGroupDetailCd = StringUtil.repMenuGrpDtlCd(menuGroupDetailCd);

            if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd) || this.isSCMSDirect ) {
                if(
                    REPAIR_MENU.includes(menuGroupDetailCd)
                ) {
                    let symptomTypeList = [];
                    fetchCodeCombo('SYMPTOM_TYPE', detail.PRD_CATEGORY_CD2).then(rtn => {
                        symptomTypeList = this.reworkCode(rtn.data.result);
                        // 증상 코드 유형은 복잡하여 별도 함수로 분리
                        this.symptomList= data.symptomList.rowCount > 0 ? this.setSymptomList(data.symptomList.rowData, detail.PRD_CATEGORY_CD2, symptomTypeList) : [{ SYMPTOM_TYPE: '', SYMPTOM_TYPE1: '',  SYMPTOM_TYPE_CODE: '', SYMPTOM_TYPEList: symptomTypeList, SYMPTOM_TYPE1List: [] }];
                    });
                };
            }

            // Detail data list 를 받을 시에는 old 가 있는 경우 old 도 같이 넣어준다.
            this.modelList              = data.modelList.rowCount > 0 ? data.modelList.rowData : [];
            this.oldModelList           = data.modelList.rowCount > 0 ? data.modelList.rowData : [];

            this.attachFileSeq          = data.attach.rowCount > 0 ? data.attach.rowData : [];
            this.oldAttachFileSeq       = data.attach.rowCount > 0 ? data.attach.rowData : [];

            // 이노릭스 리셋
            EventBus.$emit('innorix-reset-file-list', {
              uploadId: this.getUploadId,
                fileList: this.attachFileSeq,
            });

            // SerialList 의 경우에는 InputBox 때문에 초기화 작업이 필요 -> { SERIAL_S: '', SERIAL_E: '' }
            this.serialList             = data.serialList.rowCount > 0 ? data.serialList.rowData : [ { SERIAL_S: '', SERIAL_E: '' } ];
            this.oldSerialList          = data.serialList.rowCount > 0 ? data.serialList.rowData : [];

            // Part list
            this.partsList              = data.partsList.rowCount > 0 ? data.partsList.rowData : [];
            this.oldPartsList           = data.partsList.rowCount > 0 ? data.partsList.rowData : [];

            // Subsidiary Popup 생성 후
            this.selectSubsidiary       = data.subsidiaryList.rowCount > 0 ? data.subsidiaryList.rowData.map((s) => s.SUB_NM ) : [];
            this.oldSelectSubsidiary    = data.subsidiaryList.rowCount > 0 ? data.subsidiaryList.rowData.map((s) => s.SUB_NM ) : [];

            this.versionList            = data.version.rowData;

            this.knowledgeDetail        = detail;

            this.scmsYn                 = StringUtil.strToBool(detail.SCMS_YN);

            // 이전 버전 존재 확인
            try {
                if(StringUtil.isNull(this.knowledgeDetail['PREVIOUS_ID'])) {
                    this.isPrevious = false;
                } else {
                    this.isPrevious = true;
                };

            } catch(e) {
                this.isPrevious = false;
            }

            // Recommendation Add contents 인 경우, Model List 와 Parts List 는 초기화한다.
            if(this.isServiceScript && StringUtil.nvl(this.serviceScriptType) === 'RE') {
                Vue.$log.info('▶ KnowledgeContentsPopup.vue Recommendation Service Script => Model / Parts list reset.');
                this.modelList      = [];
                this.oldModelList   = [];
                this.partsList      = [];
                this.oldPartsList   = [];
            }

            this.$nextTick(() => { this.isLoading = false; })
        },
        // SCMS 필드 사용 여부 + Repair tip 메뉴 여부
        setSCMSField(menuGroupDetailCd = this.params.menuGrpDetailCd) {
            let menuGrpDtlCd = this.isSCMSDirect ? this.cttType : StringUtil.repMenuGrpDtlCd(menuGroupDetailCd);
            if(!StringUtil.isNull(menuGrpDtlCd)) {
                // SCMS Contents
                if( _.includes(SCMS_CONTENTS_CD, menuGrpDtlCd) || this.isSCMSDirect ) {
                    if(
                        REPAIR_MENU.includes(menuGrpDtlCd)
                    ) {
                        this.isRepair = true;
                        this.rtAndSb = false;
                        if( this.MENU_GROUP_DETAIL_CD === 'RT' || this.params.menuGrpDetailCd === 'RT' || this.cttType === 'RT' ) this.rtAndSb = true;
                        if( this.MENU_GROUP_DETAIL_CD === 'SB' || this.params.menuGrpDetailCd === 'SB' || this.cttType === 'SB' ) this.rtAndSb = true;
                    };

                    this.isSCMSContents = true;

                    // SCMS 인 경우 -> init Datepicker type Month, v-if 이후 딜레이 현상으로 인해 nextTick 처리
                    this.$nextTick(() => {
                        this.MANF_RANGE_DATE = DatePicker.createRangeWithOpener(
                            'from-picker-container', 'fromDate', 'icoFromDate',
                            'to-picker-container', 'toDate', 'icoToDate',
                            { type: 'month', locale: 'en', showToday: false },
                            this.MANF_FROM_DATE, this.MANF_TO_DATE
                        );
                    });

                } else {
                    this.isRepair = false;
                    this.isSCMSContents = false;
                    this.rtAndSb = false;
                }

            } else {
                this.isRepair = false;
                this.isSCMSContents = false;
                this.rtAndSb = false;
            }
        },
        async setSymptomList(sList, cat2Val, symptomTypeList = []) {
            let that = this, tmpSymptomList = [];
            let defList = [{ SYMPTOM_TYPE: '', SYMPTOM_TYPE1: '',  SYMPTOM_TYPE_CODE: '', SYMPTOM_TYPEList: [], SYMPTOM_TYPE1List: [] }];
            // 기본적으로 증상코드 유형이 1개만 있을 경우
            if(sList.length === 1) {
                let sList1 = sList[0], symptomTypeList1 = [];
                await fetchCodeCombo('SYMPTOM_TYPE1', cat2Val, sList1.C_CODE_VAL, '').then(data => {
                    symptomTypeList1 = this.reworkCode(data.data.result);
                    tmpSymptomList.push({
                        SYMPTOM_TYPE: sList1.C_CODE_VAL,
                        SYMPTOM_TYPE1: sList1.CODE_VAL,
                        SYMPTOM_TYPE_CODE: sList1.SYMPTOM_TYPE_CODE,
                        SYMPTOM_TYPEList: symptomTypeList,
                        SYMPTOM_TYPE1List: symptomTypeList1
                    });
                });
            // Service Tip 처럼 여러개인 경우
            } else {
                for(let i = 0; i < sList.length; i++) {
                    let sList1 = sList[i], symptomTypeList1 = [];
                    await fetchCodeCombo('SYMPTOM_TYPE1', cat2Val, sList1.C_CODE_VAL, '').then(data => {
                        symptomTypeList1 = this.reworkCode(data.data.result);
                        tmpSymptomList.push({
                            SYMPTOM_TYPE: sList1.C_CODE_VAL,
                            SYMPTOM_TYPE1: sList1.CODE_VAL,
                            SYMPTOM_TYPE_CODE: sList1.SYMPTOM_TYPE_CODE,
                            SYMPTOM_TYPEList: symptomTypeList,
                            SYMPTOM_TYPE1List: symptomTypeList1
                        });
                    });
                }
            }

            this.symptomList = tmpSymptomList;
            this.oldSymptomList = tmpSymptomList;
        },

        // Multiple Symptom code
        getSymptomId(v, i)  { return v + "_" + String(i); },

        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        // Board1 setting
        setBoardType1() {
            this.getCodeComboList(this.getUserCorpCd, "BOARD_TYPE1").then(data => {
                this.BOARD_TYPE1    = this.getSelBoardType1;
                this.boardType1List = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // Board2 setting
        setBoardType2() {
            this.getCodeComboList(this.getSelBoardType1, "BOARD_TYPE2").then(data => {
                this.BOARD_TYPE2    = this.getSelBoardType2;
                this.boardType2List = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ that.setBoardAccess(); }, 100 );
            });
        },
        // Board information
        setBoardAccess() {
            // DOM 생성 이 후
            if(!StringUtil.isNull(document.getElementById('BOARD_TYPE2'))) {
                for(let option of document.getElementById('BOARD_TYPE2')) {
                    if(option.value === this.getSelBoardType2 && !StringUtil.isNull(option.getAttribute('data-menu-grp-dtl-cd'))) {
                        this.MENU_GROUP_DETAIL_CD = StringUtil.repMenuGrpDtlCd(option.getAttribute('data-menu-grp-dtl-cd'));
                    }
                };
            }

            let selMenuGrpDtlCd = this.isBoardAccess ? this.getMenuGrpCd : this.MENU_GROUP_DETAIL_CD;

            this.setSCMSField(selMenuGrpDtlCd);

            //alert(this.getSelBoardType1 +"/"+ this.getSelBoardType2)
            this.setVerifyUseYn({ BOARD_TYPE1: this.getSelBoardType1, BOARD_TYPE2: this.getSelBoardType2 });
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';
                this.boardInfo = {};

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE2").then(data => {
                    this.boardType2List = data;
                });

                this.BOARD_TYPE2 = StringUtil.nvl(this.getSelBoardType2);
                this.setVerifyUseYn({ BOARD_TYPE1: this.getSelBoardType1, BOARD_TYPE2: this.getSelBoardType2 });
            }
        },
        // Board2 combo change event
        changeBoardType2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue !== "") {
                this.setBoardAccess();
            }
        },
        // 결재/검증 사용 여부 확인
        setVerifyUseYn(boardType = { BOARD_TYPE1: '', BOARD_TYPE2: '' }) {
            if(!StringUtil.isNull(boardType.BOARD_TYPE1) && !StringUtil.isNull(boardType.BOARD_TYPE2)) {
                // SCMS에서 접속한 경우, 무조건 결재 팝업 실행
                if(this.isSCMSDirect) {
                    this.verifyUseYn = true;

                } else {
                    const boardInfo = fetchBoardInfo(boardType);
                    boardInfo.then(res => {
                        let data = res.data.boardInfo.rowData[0];
                        if(!StringUtil.isNull(data['VERIFY_USE_YN']) && data['VERIFY_USE_YN'] === 'Y') {
                            this.verifyUseYn = true;
                        }
                    });
                }
            }
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.PRD_CATEGORY_CD1   = this.getSelCategory1;
                this.categoryComboList1 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 두번째 카테고리 설정
        setCategory2() {
            this.getCodeComboList(this.getSelCategory1, "ADM_CATEGORY_B").then(data => {
                this.PRD_CATEGORY_CD2   = this.getSelCategory2;
                this.categoryComboList2 = data;

                fetchCodeCombo('SYMPTOM_TYPE', this.PRD_CATEGORY_CD2).then(rtn => {
                    let dataList = this.reworkCode(rtn.data.result);
                    if(dataList.length > 0){
                        for(let idx = 0; idx < this.symptomList.length; idx++){
//                             this.symptomList[idx].SYMPTOM_TYPE      = '';
                            this.symptomList[idx].SYMPTOM_TYPEList  = dataList;
                            this.symptomList[idx].SYMPTOM_TYPE_CODE = dataList[0].parentCode;
                        }
                    }
                });
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 세번째 카테고리 설정
        setCategory3() {
            this.getCodeComboList(this.getSelCategory2, "ADM_CATEGORY_C").then(data => {
                this.PRD_CATEGORY_CD3   = this.getSelCategory3;
                this.categoryComboList3 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList2 = []; this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = []; this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = []; this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = []; this.symptomList[idx].SYMPTOM_TYPE1    = '';
                    this.symptomList[idx].SYMPTOM_TYPE_CODE  = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2   = '';
                    this.categoryComboList2 = data;
                });

                this.PRD_CATEGORY_CD3 = ''; this.categoryComboList3 = [];
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = []; this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = []; this.symptomList[idx].SYMPTOM_TYPE1    = '';
                    this.symptomList[idx].SYMPTOM_TYPE_CODE  = '';
                }
            }
            //must read select Y/N
            this.getMustReadYn();
        },

        // must read select Y/N
        getMustReadYn(){
        	if(('SB' === this.params.menuGrpDetailCd || this.cttType === 'SB' || this.MENU_GROUP_DETAIL_CD === 'SB') || ('KSBL' === this.params.menuGrpDetailCd || this.cttType === 'KSBL' || this.MENU_GROUP_DETAIL_CD === 'KSBL')){
        		this.mustreadYn = false;
        	}
        },
        // 두번째 카테고리 변경 이벤트
        async changeCategory2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList3 = []; this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = []; this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = []; this.symptomList[idx].SYMPTOM_TYPE1    = '';
                    this.symptomList[idx].SYMPTOM_TYPE_CODE  = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = ''; this.categoryComboList3 = data;
                    for(let idx = 0; idx < this.symptomList.length; idx++){
                        this.symptomList[idx].SYMPTOM_TYPEList   = []; this.symptomList[idx].SYMPTOM_TYPE     = '';
                        this.symptomList[idx].SYMPTOM_TYPE1List  = []; this.symptomList[idx].SYMPTOM_TYPE1    = '';
                        this.symptomList[idx].SYMPTOM_TYPE_CODE  = '';
                    }
                });

                await fetchCodeCombo('SYMPTOM_TYPE', comboValue).then(data => {
                    let dataList = this.reworkCode(data.data.result);
                    if(dataList.length > 0){
                        for(let idx = 0; idx < this.symptomList.length; idx++){
                            this.symptomList[idx].SYMPTOM_TYPE      = '';
                            this.symptomList[idx].SYMPTOM_TYPEList  = dataList;
                            this.symptomList[idx].SYMPTOM_TYPE_CODE = dataList[0].parentCode;
                        }
                    }
                });
            }
        },
        // 세번째 카테고리 변경 이벤트 (20.06.29 증상코드 변경은 카테고리 lv2 에서 진행)
        async changeCategory3(e) {
            /*
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.PRD_CATEGORY_CD3 = ''; this.categoryComboList3 = [];
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = []; this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = []; this.symptomList[idx].SYMPTOM_TYPE1    = '';
                    this.symptomList[idx].SYMPTOM_TYPE_CODE  = '';
                }

            } else {
                await fetchCodeCombo('SYMPTOM_TYPE', comboValue).then(data => {
                    let dataList = this.reworkCode(data.data.result);
                    if(dataList.length > 0){
                        for(let idx = 0; idx < this.symptomList.length; idx++){
                            this.symptomList[idx].SYMPTOM_TYPE      = '';
                            this.symptomList[idx].SYMPTOM_TYPEList  = dataList;
                            this.symptomList[idx].SYMPTOM_TYPE_CODE = dataList[0].parentCode;
                        }
                    }
                });
            }
            */
        },
        // 증상 콤보 박스 변경
        async changeSymptomType(idx, e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.symptomList[idx].SYMPTOM_TYPE1     = '';
                this.symptomList[idx].SYMPTOM_TYPE1List = [];

            } else {
                await fetchCodeCombo('SYMPTOM_TYPE1', this.PRD_CATEGORY_CD2, comboValue, '').then(data => {
                    let dataList = this.reworkCode(data.data.result);
                    this.symptomList[idx].SYMPTOM_TYPE1     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List = dataList;
                });
            }
        },
        reworkCode(codeObj) {
            let codeList = [];
            for(let i = 0; i < codeObj.length; i++) {
                let key = 'code' + String(i);
                codeList.push(codeObj[key]);
            }

            return codeList;
        },
        // Important/Mustread check event
        setCheckImpRead(e) {
            // Important 와 Must Read 는 둘 중 하나만 선택 가능하다.
            let self = e.target, imp = this.importantYn, must = this.mustreadYn;
            if(imp && must) { if(self.name == 'importantYn') { this.mustreadYn = false; } else { this.importantYn = false; } }
        },
        // CrossEditor reset function
        resetTemplate(){
            const CE = window[this.getEditorId];
            SDLUtil.confirm({
                msg: 'MESSAGE.KNOWLEDGE.DELETE.TEMPLATE',
                okLabel: 'BUTTON.GLOBAL.OK',
                cancelLabel: 'BUTTON.GLOBAL.CANCEL',
                onOkEvt: () => { CE.SetValue(""); },
                onCancelEvt: () => { return false; },
            });
        },
        // 임시저장, 등록 시, validation 후 오브젝트 생성
        setContParamObj(type = 'draft') {
            let that = this,    // return 이후 scope가 변경되므로 that 으로 this 상태 저장
                isRegister = ( ['register', 'reprocess'].includes(type) ? true : false );

            return new Promise(function(resolve) {
                // Validation check 'groupId : description'
                if(SDLUtil.onSubmitValidation('description')) {
                    let validList = SDLUtil.getValidList(), validId = '';
                    for(let valid of validList) {
                        if(_.find(valid.el.classList, function(c){ return c === 'warning'; }) == 'warning') {
                            validId = valid.el.id;
                        }
                    };

                    return resolve({ result: false, validId: validId });
                };

                // 등록일 경우, version history 체크
                if(isRegister && SDLUtil.onSubmitValidation('history')) {
                    let validList = SDLUtil.getValidList(), validId = '';
                    for(let valid of validList) {
                        if(_.find(valid.el.classList, function(c){ return c === 'warning'; }) == 'warning') {
                            validId = valid.el.id;
                        }
                    };

                    return resolve({ result: false, validId: validId });
                };

                // CrossEditor blank check
                const CEblankTxt = "<p><br /></p>";
                let knowledgeDesc = '', knowledgeDescBody = '';
                try {
                    knowledgeDesc = window[that.getEditorId].GetValue();
                    knowledgeDescBody = _.replace(window[that.getEditorId].GetBodyValue(), /(\r?\n)/g, '');

                } catch(e){
                    knowledgeDesc = window[that.getEditorId].GetValue();
                    knowledgeDescBody = _.replace(window[that.getEditorId].GetBodyValue(), /(\r?\n)/g, '');
                }

                let bulletinTemp = document.createElement('html'),
                    //repairTemp   = document.createElement('html'),
                    callTemp     = document.createElement('html'),
                    blankTemp    = document.createElement('html');

                    bulletinTemp.innerHTML = ServiceBulletinTemp,
                    //repairTemp.innerHTML = RepairTipTemp,
                    callTemp.innerHTML = CallGuideTemp,
                    blankTemp.innerHTML = BlankTemp;

                // Knowledge description 체크
                if(
                    StringUtil.isNull(knowledgeDescBody)
                 || knowledgeDescBody === CEblankTxt
                 || knowledgeDescBody === bulletinTemp.getElementsByTagName('body')[0].innerHTML.trim()
                 //|| knowledgeDescBody === repairTemp.getElementsByTagName('body')[0].innerHTML.trim()
                 || knowledgeDescBody === callTemp.getElementsByTagName('body')[0].innerHTML.trim()
                 || knowledgeDescBody === blankTemp.getElementsByTagName('body')[0].innerHTML.trim()
                ) {
                    return resolve({ result: false, validId: 'KNOWLEDGE_DESC' });
                };

                // add prefix  => ex) [Mobile:SB] this is title
                that.KNOWLEDGE_TITLE = StringUtil.createSubject(that.getMenuGrpCd, that.getGBMCode, that.KNOWLEDGE_TITLE);

                // Default parameters
                let params = {
                    result              : true,
                    BOARD_ID            : that.boardId,
                    BOARD_TYPE1         : that.getSelBoardType1,
                    BOARD_TYPE2         : that.getSelBoardType2,
                    PRD_CATEGORY_CD1    : that.PRD_CATEGORY_CD1,
                    PRD_CATEGORY_CD2    : that.PRD_CATEGORY_CD2,
                    PRD_CATEGORY_CD3    : that.PRD_CATEGORY_CD3,
                    KNOWLEDGE_ID        : that.KNOWLEDGE_ID,
                    KNOWLEDGE_TITLE     : that.KNOWLEDGE_TITLE,
                    KNOWLEDGE_DESC      : knowledgeDesc,
                    IMPORTANCE_YN       : StringUtil.boolToStr(that.importantYn),
                    MUST_READ_YN        : StringUtil.boolToStr(that.mustreadYn),
                    DIST_TARGET         : that.DIST_TARGET,
                    SUBSIDIARY_LIST     : that.selectSubsidiary.join(','),
                    ALLOW_SHARE         : StringUtil.boolToStr(that.isAllowSharing),
                    EXTERNAL_SHARE      : StringUtil.boolToStr(that.isExternalSharing),
                    SAVE_TYPE           : (type === 'register') ? 'R' : 'D',  // 저장 시 type 확인
                    CTTID               : that.CTTID,
                    VERIFY_USE_YN       : that.verifyUseYn ? 'Y' : 'N',
                    OLD_APPROVAL_ID     : that.knowledgeDetail.APPROVAL_ID || '',
                    CTT_TYPE            : that.cttType || '',
                };

                that.setVerifyUseYn({ BOARD_TYPE1: that.getSelBoardType1, BOARD_TYPE2: that.getSelBoardType2 });

                // Model List
                if(that.modelList.length > 0) {
                    params.selectedModel = [];
                    for(let i = 0; i < that.modelList.length; i++) {
                        params.selectedModel.push(that.modelList[i].CDMODEL);
                    }
                } else {
                    params.selectedModel = [];
                };

                // Parts List
                if(that.partsList.length > 0) {
                    params.selectedParts = [];
                    for(let i = 0; i < that.partsList.length; i++) {
                        params.selectedParts.push( that.partsList[i].PARTS_CODE + ":" + that.partsList[i].PARTS_TYPE );
                    }
                } else {
                    params.selectedParts = [];
                };

                // attachFileSeq
                if(that.attachFileSeq.length > 0) {
                    let tempAttachList = [];
                    for(let i = 0; i < that.attachFileSeq.length; i++) {
                        tempAttachList.push(that.attachFileSeq[i].attachFileSeq);
                    }
                    params.attachFileSeq = tempAttachList || [];
                } else {
                    params.attachFileSeq = [];
                }

                // Additional parameter for SCMS
                if(that.isSCMSContents) {
                    let mFormat = 'yyyyMM';
                    Object.assign(params, {
                        MANUFACTURE_S_DT    : that.MANF_RANGE_DATE.getStartDate() ? moment(that.MANF_RANGE_DATE.getStartDate()).formatWithJDF(mFormat) : '',
                        MANUFACTURE_E_DT    : that.MANF_RANGE_DATE.getEndDate() ? moment(that.MANF_RANGE_DATE.getEndDate()).formatWithJDF(mFormat) : '',
                        SERIAL_LIST         : JSON.stringify(that.serialList),
                        GUIDE_TYPE          : that.guideType,
                        DEFECT_TYPE         : that.defectType,
                    });
                };

                // SCMS 직접 접근인 경우, CTTID 리턴을 위해 플래그 추가
                if(that.isSCMSDirect) {
                    Object.assign(params, {
                        SCMS_DIRECT     : "Y",
                        CTT_TYPE        : StringUtil.nvl(that.cttType),
                        SCMS_MODEL_CD   : StringUtil.nvl(that.scmsModelCd),
                        ECN_NO          : StringUtil.nvl(that.scmsEcnNo),
                    });
                };

                // Additional parameter Repair Menu Group Detail Code -> Symptom List
                if(that.isRepair) {
                    if(that.symptomList.length > 0) {
                        params.selectedSymptom = [];
                        if(!StringUtil.isNull(that.symptomList[0].SYMPTOM_TYPE)) {
                            for(let i = 0; i < that.symptomList.length; i++) {
                                // symptomType + ":" + symptomType1
                                if(!StringUtil.isNull(that.symptomList[i].SYMPTOM_TYPE)) {
                                    params.selectedSymptom.push(
                                        that.symptomList[i].SYMPTOM_TYPE + ":" + that.symptomList[i].SYMPTOM_TYPE1 + ":" + that.symptomList[i].SYMPTOM_TYPE_CODE
                                    );
                                };
                            }

                            Vue.$log.info('▶ KnowledgeContentsPopup.vue selectedSymptomList =>', params.selectedSymptom);
                        };
                    };
                };

                // 등록일 경우 변경 사유를 params에 넣어준다.
                if(isRegister) {
                    Object.assign(params, { MODF_REASON: that.versionDesc || '' });
                };

                // Reprocess 일 경우, ServiceScriptId 추가
                if(type === 'reprocess' && that.isServiceScript) {
                    Object.assign(params, { SERVICE_SCRIPT_ID: that.SERVICE_SCRIPT_ID, SHOW_TYPE: that.serviceScriptType });
                };

                // Request Sharing Contents 일 경우
                if(that.isRequestSharing && !StringUtil.isNull(that.shareId)) {
                    Object.assign(params, { SHARE_ID: that.shareId });
                };

                Vue.$log.info('▶ KnowledgeContentsPopup.vue save contents =>', params);

                return resolve(params);
            });
        },

        loadAllSubsidiary() {
            return SDLUtil.postForm('/basis/knowledge/findAllSubsidiaryList.skp', {}).then(data => {
                let result = data.result;
                if(result.rowCount > 0) {
                    let rowData = result.rowData;
                    this.selectSubsidiary = rowData.map((s) => s.SUB_NM );

                } else {
                    this.selectSubsidiary = [];
                }
            })
        },

        // ## Contents 에서 사용하는 Popup function : START
        globalTargetPop() {
            SDLUtil.show(
                KnowledgeTargetPopup,
                {
                    selTargetList: this.selectSubsidiary,
                    isRequestSharing: this.isRequestSharing,
                    requesterId: this.requesterId,
                    rtnFunc: (list = []) => {
                        // Subsidiary Target popup 에서 받아온 리스트를 sort 하여 담는다.
                        this.selectSubsidiary = list.sort();
                    }
                },
                { height: 'auto' }
            );
        },
        // CrossEditor template popup
        templatePop() {
            SDLUtil.show(
                KnowledgeTemplatePopup,
                {
                    rtnFunc: (doc) => {
                        // Template return callback function
                        window[this.getEditorId].SetValue(doc);
                    }
                },
                { height: 'auto' }
            );
        },
        // UTrans popup event
        translationPop() {
            SDLUtil.show(
                TransPopup,
                {
                    bodyText: StringUtil.removeHtmlTag(window[this.getEditorId].GetBodyValue())
                },
                { height: 'auto' }
            );
        },
        // ImageCloud Popup
        imageCloudPop() {
            return SDLUtil.show(
                ImageCloudListPopup,
                {
                    rtnFunc: returnObj => {
                        window[this.getEditorId].InsertImage(returnObj.crossUrl);
                    }
                },
                { height: 'auto' },
            );
        },

        // Sample file download
        downloadWithAxios(type){
            let sampleUrl = '';
            if(type === 'model') {
                sampleUrl = `${SDLUtil.API_URL}/static/sample/Model_List_sample.xlsx`;
            } else if (type === 'parts'){
                sampleUrl = `${SDLUtil.API_URL}/static/sample/Parts_List_sample.xlsx`;
            } else {
                return false;
            };

            return axios({
                method: 'get',
                url: sampleUrl,
                responseType: 'arraybuffer'
            })
            .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                let fileName = (type === 'model' ? 'Model_List_sample.xlsx' : 'Parts_List_sample.xlsx');
                if (window.navigator.msSaveOrOpenBlob) {
                    // IE 10+
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {
                    // not IE
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.target = '_self';
                    if (fileName) link.download = fileName;
                    link.click();
                }
            })
        },

        // 20241118 ke01.liu excel template download
        sampleExcelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Sample Excel.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/downloadSampleExcel.skp`,
                            qs.stringify({}),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },

        // 모델 조회 팝업, return 될 때 model list 에 선택된 값을 넣어준다.
        modelSearchPop() {
            // corpNoList 는 targetType 이 S 일 때는 Code 값, G 일 때는 Name 값이 들어간다.
            console.log(this.scmsCategoryCd1 + ' - ' + this.scmsCategoryCd2 + ' - ' + this.scmsCategoryCd3);
            SDLUtil.show(
                KnowledgeModelPopup,
                {
                    searchModel: this.searchModel,
                    targetType: this.DIST_TARGET,
                    corpNoList: (this.DIST_TARGET === 'S') ? [ this.getUserCorpCd ] : this.selectSubsidiary,
                    categoryCd1: this.getSelCategory1,
                    categoryCd2: this.getSelCategory2,
                    categoryCd3: this.getSelCategory3,
                    rtnFunc: selModelList => {
                        for(let i = 0; i < selModelList.length; i++) {
                            if(_.findIndex(this.modelList, function(m){ return m.CDMODEL == selModelList[i].CDMODEL; }) > -1) {
                                // 중복으로 들어가는 경우 패스한다.
                            } else {
                                this.modelList.push({
                                    CDMODEL: selModelList[i].CDMODEL,
                                    NMMODEL: selModelList[i].NMMODEL,
                                    CDCOMPANY: selModelList[i].CDCOMPANY,
                                    NMCOMPANY: selModelList[i].NMCOMPANY,
                                    MAKETNM: selModelList[i].MAKETNM,
                                    CDGBM: selModelList[i].CDGBM
                                });
                            };

                            if(this.modelList.length > 0) {
                                this.GBM_CD = this.modelList[0].CDGBM;
                                this.KNOWLEDGE_TITLE = StringUtil.createSubject(this.getMenuGrpCd, this.getGBMCode, this.KNOWLEDGE_TITLE);

                                let grid = this.$refs[this.modelGridId].$refs[this.modelGridId];
                                grid.invoke('resetData', this.modelList);
                            };
                        }
                    }
                },
                { height: 'auto' }
            );
        },

        // 버전 상세 보기 팝업
        seeDetailPop(knowledgeId, knowledgeVer) {
            Vue.$log.info("▶ KnowledgeContentsPopup.vue See Detail Popup => ", knowledgeId, knowledgeVer);
            SDLUtil.show(
                KnowledgeVersionDetailPopup,
                {
                    KNOWLEDGE_ID: knowledgeId,
                    VERSION_NO: knowledgeVer
                },
                { height: 'auto' }
            );
        },

        // 결재 이력 보기 팝업
        seeApprovalHistoryPop(approvalId) {
            Vue.$log.info("▶ KnowledgeContentsPopup.vue See Approval History Popup => ", approvalId);
            SDLUtil.show(
                ApprovalHistoryPopup,
                {
                    approvalId: approvalId
                },
                { height: 'auto' }
            );
        },

        // 복제 이전 버전 보기
        seePrevPop() {
            Vue.$log.info("▶ KnowledgeContentsPopup.vue See Previous Popup");
            let prevId = this.knowledgeDetail['PREVIOUS_ID'] || '';
            if(!StringUtil.isNull(prevId)) {
                SDLUtil.show(
                    KnowledgePreviousPopup,
                    {
                        KNOWLEDGE_ID: prevId
                    },
                    { height: 'auto' }
                );
            }
        },

        /**
         *    - 팝업 내부에서 사이즈 조정으로 데스크탑 / 태블릿 / 모바일 화면 구현
         *      - 768px 미만 : Mobile
         *      - 768px ~ 1024px : Tablet
         *      - 1024px 초과 : Desktop
         */
        btnPreview() {
            let detailParam = {
                IMPORTANCE_YN: StringUtil.boolToStr(this.importantYn),
                MUST_READ_YN: StringUtil.boolToStr(this.mustreadYn),
                KNOWLEDGE_TITLE: this.KNOWLEDGE_TITLE,
                KNOWLEDGE_DESC: window[this.getEditorId].GetValue()
            };

            SDLUtil.show( KnowledgePreviewPopup, { DETAIL: detailParam }, { height: 'auto' } );
        },
        // 결재 팝업
        approvalPop() {
            let that = this;
            // 결재 사용 여부 확인 (단, SCMS 컨텐츠 작성은 무조건 결재를 한다.)
            if(this.verifyUseYn || this.isSCMSDirect) {
            	if('SB' === this.params.menuGrpDetailCd || this.cttType === 'SB' || this.MENU_GROUP_DETAIL_CD === 'SB'){
            		// 결재 팝업 오픈
                    SDLUtil.show(
                        ApprovalPopup,
                        {
                            title:           that.KNOWLEDGE_TITLE,
                            guideType:       that.guideType,
                            prdCategoryCd1:  that.PRD_CATEGORY_CD1,
                            // service  bulletin approvel
                            serviceBulletinYn: 'SB',
                            workTable:       'T_KNOWLEDGE',
                            workColumn:      'KNOWLEDGE_ID',
                            workKey:         that.KNOWLEDGE_ID,
                            firstApprovalYn: that.versionList.length === 1 ? 'Y' : 'N',
                            // 결재 완료 후 등록 실행
                            rtnFunc: (v) => {
                                if(v) that.registerSave();
                            }
                        },
                        { height: 'auto' }
                    );
            	}else{
            		SDLUtil.confirm({
                        title: 'BUTTON.GLOBAL.APPROVAL',
                        msg: 'MESSAGE.APPROVAL.NECESSITY',
                        okLabel: 'BUTTON.GLOBAL.APPROVAL',
                        cancelLabel: 'BUTTON.GLOBAL.NONEED',
                        onOkEvt: () => {
                            that.$nextTick(() => {
                                // 결재 팝업 오픈
                                SDLUtil.show(
                                    ApprovalPopup,
                                    {
                                        title:           that.KNOWLEDGE_TITLE,
                                        guideType:       that.guideType,
                                        prdCategoryCd1:  that.PRD_CATEGORY_CD1,
                                        serviceBulletinYn: '',
                                        workTable:       'T_KNOWLEDGE',
                                        workColumn:      'KNOWLEDGE_ID',
                                        workKey:         that.KNOWLEDGE_ID,
                                        firstApprovalYn: that.versionList.length === 1 ? 'Y' : 'N',
                                        // 결재 완료 후 등록 실행
                                        rtnFunc: (v) => {
                                            if(v) that.registerSave();
                                        }
                                    },
                                    { height: 'auto' }
                                );
                            });
                        },
                        // 결재 불필요 No Needs
                        onCancelEvt: () => {
                            this.registerSave(true);
                        }
                    });
            	}

            } else {
                Vue.$log.warn('▶ KnowledgeContentsPopup.vue => This board type does not require approval.');
            }
        },
        // 결재 팝업
        addContentsApprovalPop() {
            let that = this;
            if(this.verifyUseYn) {
                SDLUtil.confirm({
                    title: 'BUTTON.GLOBAL.APPROVAL',
                    msg: 'MESSAGE.APPROVAL.NECESSITY',
                    okLabel: 'BUTTON.GLOBAL.APPROVAL',
                    cancelLabel: 'BUTTON.GLOBAL.NONEED',
                    onOkEvt: () => {
                        return SDLUtil.postForm(
                            '/basis/myKnowledge/serviceScript/serviceScriptChangeStatus.skp',
                            {
                                KNOWLEDGE_ID: that.KNOWLEDGE_ID,
                                OLD_KNOWLEDGE_ID: that.OLD_KNOWLEDGE_ID,
                                CORP_NO: that.CORP_NO,
                                SERVICE_SCRIPT_ID: that.SERVICE_SCRIPT_ID,
                                VERIFY_USE_YN: that.verifyUseYn,
                                SHOW_TYPE: that.serviceScriptType
                            }
                        ).then(data => {
                            Vue.$log.info('▶ KnowledgeContentsPopup.vue changeApprovalStatus.', data);
                            if(data.success) {
                                // 결재 팝업 오픈
                                SDLUtil.show(
                                    ApprovalPopup,
                                    {
                                        title:           that.KNOWLEDGE_TITLE,
                                        workTable:       'T_KNOWLEDGE',
                                        workColumn:      'KNOWLEDGE_ID',
                                        workKey:         that.KNOWLEDGE_ID,
                                        firstApprovalYn: that.versionList.length === 1 ? 'Y' : 'N',
                                        // 결재 완료 후 등록 실행
                                        rtnFunc: (v) => {
                                            Vue.$log.info(v);
                                            that.closePopup();
                                        }
                                    },
                                    { height: 'auto' }
                                );

                            } else {
                                return SDLUtil.alert({ title: 'TITLE.WARNING.TITLE', msg: data.msg });
                            }
                        });
                    },
                    // 결재 불필요 No Needs
                    onCancelEvt: () => {
                        that.closePopup();
                    }
                });

            } else {
                Vue.$log.warn('▶ KnowledgeContentsPopup.vue => This board type does not require approval.');
            }
        },
        // ## Contents 에서 사용하는 Popup function : END

        // ## Contents 에서 사용하는 Button function : START
        // 증상콤보 생성/제거 이벤트 - symptomList 는 복수개가 생성될 수 있다.
        btnAddSymptom()         {
            this.symptomList.push({
                SYMPTOM_TYPE: '', SYMPTOM_TYPE1: '', SYMPTOM_TYPE_CODE: '',
                SYMPTOM_TYPEList: this.symptomList[0].SYMPTOM_TYPEList,
                SYMPTOM_TYPE1List: []
            });
        },
        btnRemoveSymptom(idx)   {
            if(!StringUtil.isNull(this.symptomList[idx].SYMPTOM_TYPE) || !StringUtil.isNull(this.symptomList[idx].SYMPTOM_TYPE1)) {
                SDLUtil.confirm({
                    msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                    onOkEvt: () => { this.symptomList.splice(idx, 1); }
                });
            } else {
                this.symptomList.splice(idx, 1);
            }
        },

        // Serial 추가/제거 버튼 이벤트
        btnAddSerial()          { this.serialList.push({ SERIAL_S: '', SERIAL_E: '' }); },
        btnRemoveSerial(idx)    {
            if(!StringUtil.isNull(this.serialList[idx].SERIAL_S) || !StringUtil.isNull(this.serialList[idx].SERIAL_E)) {
                SDLUtil.confirm({
                    msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                    onOkEvt: () => { this.serialList.splice(idx, 1); }
                });
            } else {
                this.serialList.splice(idx, 1);
            }
        },
        validSerial(e, tModel) {
            let newVal = StringUtil.nvl(e.target.value, '').replace(/[^a-z0-9]/gi, '');
            tModel = newVal;
        },
        modelSampleDown() {
            return axios.get(`${SDLUtil.WEB_CONTEXT_PATH}/static/sample/Model_List_sample.xlsx`);
        },
        // 모델 리스트 업로드 (Excel)
        modelUpload(e) {
            let files = e.target.files;
            if (files.length) {
                SDLUtil.showLoadingBar(true);
                let formData = new FormData();
                    formData.append('excelFile', files[0]);

                axios.post(
                    `${SDLUtil.API_URL}/basis/common/excelUpload.skp`,
                    formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }
                )
                .then(response => {
                    let selModelList = response.data.result;
                    let lastRow = response.data.rows;

                    //console.log('modelUpload lastRow ==> ', lastRow);
                    //console.log('modelUpload response ==> ', response);

                    if(selModelList.length > 0 && lastRow <= 2000 ) {
                        // 업로드 데이터가 존재하면 기존 테이블을 초기화
                        this.modelList = [];
                        this.validFailCnt = 0;
                        let grid = this.$refs[this.modelGridId].$refs[this.modelGridId];
                            grid.invoke('resetData', this.modelList);

                        // SCMS에서 넘어오는  모델이 있는 경우 넣어준다.
                        if(this.isSCMSDirect && !StringUtil.isNull(this.scmsModelCd) && !this.isModify) {
                            this.modelList.push(this.scmsFixModel);
                        };

                        for(let i = 0; i < selModelList.length; i++) {
                            this.modelList.push({
                                CDMODEL: selModelList[i].A,
                                NMMODEL: selModelList[i].B,
                                MAKETNM: selModelList[i].C,
                                FIX_MODEL: false
                            });

                            // 마지막 데이터를 넣으면 그리드를 리로드
                            if(i === selModelList.length - 1) {
                                grid.invoke('resetData', this.modelList);
                            }
                        };

                        this.showFailCnt = true;
                        this.isModelValidation = true;
                        SDLUtil.showLoadingBar(false);
                    };
                    if ( lastRow > 2000 ) {
                        SDLUtil.showLoadingBar(false);
                   	 	return SDLUtil.alert({ title: '[Model] Exceeded the number of uploads', msg: 'The number of uploads is limited to 2000...' });
                    };
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });

                // input file reset
                this.$refs.model_file_ref.value = '';

            } else {
                SDLUtil.showLoadingBar(false);
            }
        },
        // 모델 코드 검증
        modelValidation() {
            if(this.isModelValidation && this.modelList.length > 0) {
                let that = this;
                SDLUtil.confirm({
                    title: 'BUTTON.GLOBAL.CONFIRM',
                    msg: 'MESSAGE.KNOWLEDGE.MODEL.VALIDATION.DO',
                    onOkEvt: () => {
                        SDLUtil.showLoadingBar(true);
                        let params = {
                            selectedModel : [],
                            targetType: this.DIST_TARGET,
                            corpNoStr: (this.DIST_TARGET === 'S') ? this.getUserCorpCd : this.selectSubsidiary.join(':'),
                        };

                        for(let i = 0; i < this.modelList.length; i++) {
                            params.selectedModel.push(this.modelList[i].CDMODEL);
                        };

                        axios.post(
                            `${SDLUtil.API_URL}/basis/knowledge/validModelCodeBySubsidiary.skp`,
                            qs.stringify(params),
                            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                        )
                        .then(res => {
                            let data = res.data;
                            // 검증 이후 그리드 목록 리로드
                            this.modelList = data.result.rowData;

                            let grid = this.$refs[this.modelGridId].$refs[this.modelGridId];
                                grid.invoke('resetData', this.modelList);

                            // 결과 건수
                            let validCnt    = data.validCnt,
                                successCnt  = data.successCnt,
                                failCnt     = data.failCnt;

                            // 실패 건수
                            this.validFailCnt = failCnt;
                            this.isModelValidation = false;

                            this.$nextTick(() => {
                                if(this.modelList.length > 0) {
                                    this.GBM_CD = this.modelList[0].CDGBM;
                                    this.KNOWLEDGE_TITLE = StringUtil.createSubject(this.getMenuGrpCd, this.getGBMCode, this.KNOWLEDGE_TITLE);
                                }
                            });

                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                    }
                });

            } else {
                return false;
            }
        },
        // 모델 전체 삭제
        modelAllDelete() {
            // Modify mode 에서만 동작
            if(this.getIsModify) {
                if(this.modelList.length > 0) {
                    SDLUtil.confirm({
                        msg: 'MESSAGE.DATA.DELETE.CONFIRM',
                        onOkEvt: () => {
                            this.modelList = [];
                            this.validFailCnt = 0;
                            this.isModelValidation = false;

                            // SCMS에서 넘어오는  모델이 있는 경우 넣어준다.
                            if(this.isSCMSDirect && !StringUtil.isNull(this.scmsModelCd) && !this.isModify) {
                                this.modelList.push(this.scmsFixModel);
                            };

                            let grid = this.$refs[this.modelGridId].$refs[this.modelGridId];
                                grid.invoke('resetData', this.modelList);
                        }
                    });
                }

            } else {
                return SDLUtil.alert('MESSAGE.KNOWLEDGE.MODEL.DELETE');
            }
        },
        partsSampleDown() {
            return axios.get(`${SDLUtil.WEB_CONTEXT_PATH}/static/sample/Parts_List_sample.xlsx`);
        },
        // 자재 리스트 업로드 (Excel)
        partsUpload(e) {
            let files = e.target.files;
            if (files.length) {
                SDLUtil.showLoadingBar(true);
                let formData = new FormData();
                    formData.append('excelFile', files[0]);

                axios.post(
                    `${SDLUtil.API_URL}/basis/common/excelUpload.skp`,
                    formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }
                )
                .then(response => {
                    let selPartsList = response.data.result;
                    let lastRow = response.data.rows;

                    if(response.data ==="" || selPartsList.length < 1){
                    	SDLUtil.showLoadingBar(false);
                    	return SDLUtil.alert({ title: 'Check the uploaded files', msg: 'Please confirm whether the attachment is empty or has not been processed as an NAS exception.' });
                    }
                    console.log('partsUpload lastRow ==> ', lastRow);
                    console.log('partsUpload response ==> ', response);

                    if(selPartsList.length > 0 && lastRow <= 500 ) {
	                    for(let i = 0; i < selPartsList.length; i++) {
	                        this.partsList = [];
	                        let grid = this.$refs[this.partsGridId].$refs[this.partsGridId];
	                            grid.invoke('resetData', this.partsList);

	                        for(let i = 0; i < selPartsList.length; i++) {
	                            this.partsList.push({
	                                PARTS_CODE: selPartsList[i].A,
	                                PARTS_TYPE: selPartsList[i].B,
	                            });

	                            // 마지막 데이터를 넣으면 그리드를 리로드
	                            if(i === selPartsList.length - 1) {
	                                grid.invoke('resetData', this.partsList);
	                            }
	                        };
	                    }

	                    SDLUtil.showLoadingBar(false);
                    };
                    if ( lastRow > 500 ) {
                    	SDLUtil.showLoadingBar(false);
                      	return SDLUtil.alert({ title: '[Parts] Exceeded the number of uploads', msg: 'The number of uploads is limited to 500...' });
                    };
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });

                // input file reset
                this.$refs.parts_file_ref.value = '';
            } else {
                SDLUtil.showLoadingBar(false);
            }
        },
        partsAllDelete() {
            // Modify mode 에서만 동작
            if(this.getIsModify) {
                if(this.partsList.length > 0) {
                    SDLUtil.confirm({
                        msg: 'MESSAGE.DATA.DELETE.CONFIRM',
                        onOkEvt: () => {
                            this.partsList = [];
                            let grid = this.$refs[this.partsGridId].$refs[this.partsGridId];
                                grid.invoke('resetData', this.partsList);
                        }
                    });
                }

            } else {
                return SDLUtil.alert('MESSAGE.KNOWLEDGE.MODEL.DELETE');
            }
        },
        modelColumnClick(e, rowData, grid) {
            let colNm = e.columnName, selRow = {};
            if ((typeof e.rowKey) === "undefined") return;
            for(let row of rowData) {
                if(row.rowKey === e.rowKey) {
                    selRow = row;
                    break;
                }
            };

            let modelCode = selRow['CDMODEL'] || '';
            let fixModel = selRow['FIX_MODEL'] || false;
            // Delete 컬럼 클릭 시, modify 이면서 SCMS Fix model이 아닌 경우에만 동작
            if(colNm === 'DELETE' && !fixModel) {
                if(this.getIsModify) {
                    let idx = _.findIndex(this.modelList, function(m){ return m.CDMODEL == modelCode });
                    this.modelList.splice(idx, 1);

                } else {
                    SDLUtil.alert("MESSAGE.KNOWLEDGE.MODEL.DELETE");
                }
            }

            grid.invoke('resetData', this.modelList);
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols(type = '') {
            let colType = type;
            if(!StringUtil.isNull(type)) {
                if(this.processStep === 2) {
                    colType = 'MODEL';

                } else if(this.processStep === 3) {
                    colType = 'PARTS';
                };
            }

            if(colType === 'MODEL') {
                return [
                    /* 2020.06.26 Subsidiary 컬럼 삭제 */
                    { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', width: this.getColumnSize(20), resizable: true, sortable: true,
                                filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                    { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.NAME'), name: 'NMMODEL', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true },
                    { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true },
                    { header: SDLUtil.getMsgProp('BUTTON.GLOBAL.DELETE'), name: 'DELETE', align: 'center', width: 50, renderer: { type: CustomDeleteRenderer } },
                    { header: 'CDCOMPANY',  name: 'CDCOMPANY',  hidden: true },
                    { header: 'CDGBM',      name: 'CDGBM',      hidden: true },
                    { header: 'FIX_MODEL',  name: 'FIX_MODEL',  hidden: true, defaultValue: false }
                ];

            } else if(colType === 'PARTS'){
                return [
                    /* 2020.04.06 Parts Name 컬럼 삭제 */
                    { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', width: this.getColumnSize(30), resizable: true, sortable: true },
                    { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', width: this.getColumnSize(25), resizable: true, sortable: true }
                ];

            } else {
                return [];
            }
        },
        getColumnSize(size) {
            let wrapIdx = 0;
            if(isNaN(Number(size))) { return 0; }
            if(this.processStep === 2) {
                wrapIdx = 0;
            } else if(this.processStep === 3) {
                wrapIdx = 1;
            };
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[wrapIdx].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 50) / (100 / size));
        },
        setGridResizeColumn(v) {
            // 그리드 다이나믹 컬럼
            if(v === 2) {
                EventBus.$emit('model-grid-set-column', this.getDynamicCols('MODEL'));

            } else if(v === 3) {
                EventBus.$emit('parts-grid-set-column', this.getDynamicCols('PARTS'));
            }
        },


        // 뒤로가기 버튼
        btnPrevious() {
            if(this.processStep !== 1) {
                $('.modal_content > dd').scrollTop(0);
                this.processStep = this.processStep - 1;
                if(this.processStep === 1) this.isProcess = false;
            };
        },
        // 임시 저장 버튼
        async btnSaveDraft(alertFlag = true, register = false) {
            /*
                1. 최초 임시저장 시, knowledgeId 생성 후 저장, return 된 knowledgeId를 저장한다. (this.KNOWLEDGE_ID)
                2. knowledgeId가 있는 경우, 다시 knowledgeId를 생성하지 않고 저장 프로세스 실행
                3. 등록 플래그가 있는 경우, 등록 단계 실행, 결재가 필요한 경우 결재 진행
            */
            let that = this;
            SDLUtil.showLoadingBar(true);
            await that.setContParamObj().then(params => {
                if(params.result) {
                    // Knowledge Id 가 없는 최초 저장 & 등록
                    if(StringUtil.isNull(that.KNOWLEDGE_ID)) {
                        fetchSaveDraft(params).then(res => {
                            let data = res.data;
                            if(!StringUtil.strToBool(data.success)) {
                                return SDLUtil.alert(data.msg);
                            };

                            if(!StringUtil.isNull(data.knowledgeId)) {
                                that.KNOWLEDGE_ID = data.knowledgeId;
                                that.STATUS = 'P';
                            };

                            Vue.$log.info('▶ KnowledgeContentsPopup.vue save draft complete. [KnowledgeId : ', data.knowledgeId, "] => ", data);
                            if(!register) { SDLUtil.showLoadingBar(false); };

                            if(alertFlag) {
                                // Notification
                                return that.toastMsg(SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.SUCCESS2'));
                            };

                            if(register) {
                                // 20.07.09 요청 - 등록하기 전 결재 팝업 실행, 기본적으론 각 게시판 설정을 따라가지만, SCMS 작성인 경우는 무조건 결재 필수
                                if(that.checkProductTypeAndGudideType()) {
                                    return that.approvalPop();

                                } else {
                                    // Register contents
                                    if('SB' === that.params.menuGrpDetailCd || 'SB' === that.cttType || 'SB' === that.MENU_GROUP_DETAIL_CD){
                                    	 return that.registerSave(true);
                                    }else{
                                    	 return that.registerSave();
                                    }

                                }
                            }
                        })
                        .catch(err => {
                            SDLUtil.showLoadingBar(false);
                            SDLUtil.errorAlert(err);
                        });

                    // Knowledge Id 가 있는 임시저장, 수정 & 등록
                    } else {
                        if(register) {
                            if(that.checkProductTypeAndGudideType()) {
                                return that.approvalPop();

                            } else {
                                // Register contents
                            	  // Register contents
                                if('SB' === that.params.menuGrpDetailCd || 'SB' === that.cttType || 'SB' === that.MENU_GROUP_DETAIL_CD ){
                                	 return that.registerSave(true);
                                }else{
                                	 return that.registerSave();
                                }
                            }

                        } else {
                            fetchSaveDraft(params).then(res => {
                                let data = res.data;
                                if(!StringUtil.isNull(data.knowledgeId)) {
                                    that.KNOWLEDGE_ID = data.knowledgeId;
                                    that.STATUS = 'P';
                                };

                                Vue.$log.info('▶ KnowledgeContentsPopup.vue save draft complete. [KnowledgeId : ', data.knowledgeId, "] => ", data);
                                if(!register) { SDLUtil.showLoadingBar(false); };

                                if(alertFlag) {
                                    // Notification
                                    return that.toastMsg(SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.SUCCESS2'));
                                }
                            })
                            .catch(err => {
                                SDLUtil.showLoadingBar(false);
                                SDLUtil.errorAlert(err);
                            });
                        }
                    }

                } else {
                    SDLUtil.showLoadingBar(false);
                    return that.validContentsAlert(params);
                }
            })
            .catch(err => {
                Vue.$log.error(err);
            });
        },
        // Next 진행
        btnNext() {
            if(this.processStep !== 4) {
                // 스크롤 Top
                $('.modal_content > dd').scrollTop(0);

                // 배포 유형 Global 이면서 선택하지 않은 경우 메세지 처리
                if(!this.targetAllPass){
                	if(this.processStep === 1 && this.DIST_TARGET === 'G' && this.selectSubsidiary.length === 0) {
                        return SDLUtil.alert("MESSAGE.KNOWLEDGE.GLOBAL.SELECT.SUBSIDIARY");
                    };
                }

                // 엑셀 업로드 이 후 모델 검증 필수
                if(this.processStep === 2 && this.isModelValidation) {
                    return SDLUtil.alert('MESSAGE.KNOWLEDGE.MODEL.VALIDATION');
                };

                this.isProcess = true;
                this.processStep = this.processStep + 1;
            };
        },
        // 등록 버튼 이벤트
        btnRegister() {
        	if(this.targetAllPass){
	        	if(this.DIST_TARGET === 'G' && this.selectSubsidiary.length === 0) {
	                return SDLUtil.alert("The session has expired; please close the page and log in again.");
	            };
        	};
            let that = this,
                validContents = this.regVerifyContents();

            if(validContents) {
                this.btnSaveDraft(false, true);

            } else {
                return false;
            };
        },
        // 등록 실행
        async registerSave(noNeedFlag = false) {
            let that = this;
            await this.setContParamObj('register').then(params => {
                if(params.result) {
                    // 결재를 안 할 때 ( No Need )
                    if(noNeedFlag) {
                        Object.assign(params, { 'VERIFY_PASS' : 'Y' });
                    };

                    // call Save api
                    fetchRegisterSave(params).then(res => {
                        let data = res.data;
                        if(data.success) {
                            Vue.$log.info('▶ KnowledgeContentsPopup.vue register complete. [KnowledgeId : ', data.knowledgeId, "] => ", data);
                            // 등록 완료 후, 버그리포트인 경우 팝업 종료
                            if(this.isBugReport) {
                                // Delete a Knowledge detail
                                this.closePopup('BUG');

                            } else {
                                this.loadKnowledgeDetail(data.knowledgeId).then(() => {
                                    that.isUserModify = false;
                                    that.isProcess = true;
                                    that.closePopup();
                                })
                                .catch(err => {
                                    SDLUtil.showLoadingBar(false);
                                    SDLUtil.errorAlert(err);
                                });
                            }
                        };

                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.errorAlert(err);
                    });

                } else {
                    SDLUtil.showLoadingBar(false);
                    return this.validContentsAlert(params);
                }
            })
            .catch(err => {
                SDLUtil.showLoadingBar(false);
                SDLUtil.errorAlert(err);
            });
        },
        // 삭제 버튼 이벤트
        btnDelete() {
            SDLUtil.confirm({
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/delete.skp`,
                                qs.stringify({ KNOWLEDGE_ID: this.KNOWLEDGE_ID, boardTypeRoot: this.getUserCorpCd }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'MESSAGE.SUCCESS.DELETED',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            // Delete a Knowledge detail
                                            this.closePopup('DKD');
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });

                }
            });

        },
        btnModify() {
            // 20.08.05 SCMS에서 생성한 컨텐츠는 SCMS 에서만 수정할 수 있다.

            if(this.scmsYn && !this.isSCMSDirect) {
            	if(this.IfFirstApproval && this.STATUS ==='C'){
               	 return SDLUtil.alert('This is the first login in the SCMS system and it is in a canceled or rejected state, so modifications cannot be made. You can delete it and log in again in the SCMS system.');
                }
            	return SDLUtil.alert('MESSAGE.KNOWLEDGE.CONTENTS.SCMS.ONLY');
            };
            this.isUserModify = true;
            this.$forceUpdate();
        },
        // 만료 버튼 - 사용 여부 확인
        btnExpire() {
            SDLUtil.confirm({
                title: "TITLE.WARNING.TITLE",
                msg: 'MESSAGE.DATA.EXPIRE.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/expire.skp`,
                                qs.stringify({ KNOWLEDGE_ID: this.KNOWLEDGE_ID, boardTypeRoot: this.getUserCorpCd }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            // Expire Knowledge details
                                            this.closePopup('EKD');
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
        },

        // Admin > Knowledge Manager Menu button
        btnRecover() {
            let recoverUrl = '';
            if(this.adminMenuType === 'EPD') { // Expired Knowledge
                recoverUrl = `${SDLUtil.API_URL}/basis/admin/knowledgeManager/expiredKnowledge/ExpiredKnowledgeRecover.skp`;

            } else if(this.adminMenuType === 'TRS') { // Trash
                recoverUrl = `${SDLUtil.API_URL}/basis/admin/knowledgeManager/trash/trashRecover.skp`;

            } else {
                // Admin type not found
                SDLUtil.alert({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.ERROR.REQUEST',
                    onOkEvt: () => {
                        return this.notFoundKnowledge();
                    }
                });
            };

            SDLUtil.confirm({
                title: "TITLE.WARNING.TITLE",
                msg: 'MESSAGE.DATA.RECOVER.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                recoverUrl, qs.stringify({ KNOWLEDGE_ID: this.KNOWLEDGE_ID }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            // Knowledge Recover
                                            this.closePopup('ADM');
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
        },
        btnTrash() {
            SDLUtil.confirm({
                title: "TITLE.WARNING.TITLE",
                msg: 'MESSAGE.DATA.TRASH.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/admin/knowledgeManager/expiredKnowledge/ExpiredKnowledgeTrash.skp`,
                                qs.stringify({ KNOWLEDGE_ID: this.KNOWLEDGE_ID }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            // Knowledge Trash
                                            this.closePopup('ADM');
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });

        },
        btnExtendPeriod() {
            let selKnowledge = [ this.KNOWLEDGE_ID ];
            SDLUtil.show(
                ExtendedPeriodPopup,
                {
                    knowledgeId: selKnowledge,
                    rtnFunc: () => {
                        // Knowledge Recover
                        this.closePopup('ADM');
                    }
                },
                { height: 'auto' }
            );

        },
        btnRemove() {
            SDLUtil.confirm({
                title: "TITLE.WARNING.TITLE",
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/admin/knowledgeManager/trash/trashRemove.skp`,
                                qs.stringify({ KNOWLEDGE_ID: this.KNOWLEDGE_ID }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            // Knowledge Remove
                                            this.closePopup('ADM');
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
        },
        async btnAddContentsSave() {
            // Add Contents
            // 권한 체크
            if(Number(this.getDeptLevelCd) === 1) {
                return SDLUtil.getMsgProp('MESSAGE.AUTHORITY.NOHAVE');

            } else {
                let that = this,
                    validContents = this.regVerifyContents();

                await this.setContParamObj('reprocess').then(params => {
                    // Parameter 세팅 및 Validation 진행
                    if(validContents && params.result) {
                        SDLUtil.confirm({
                            title: "BUTTON.GLOBAL.CONFIRM",
                            msg: 'MESSAGE.DATA.SAVE.CONFIRM',
                            onOkEvt: () => {
                                return that.regAddContents(params);
                            }
                        });

                    // Validation 실패 시 처리
                    } else {
                        SDLUtil.showLoadingBar(false);
                        return this.validContentsAlert(params);
                    };
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });
            }
        },
        // Add Contents 실행 시 -> 선 저장 후 결재
        regAddContents(params) {
            let that = this;
            this.OLD_KNOWLEDGE_ID = this.KNOWLEDGE_ID;
            return  axios.post(
                        `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/serviceScriptSave.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        let data = res.data;
                        if(data.success) {
                            that.KNOWLEDGE_ID = data.knowledgeId;

                            // 저장 완료 후 결재 여부가 있을 경우
                            if(that.verifyUseYn) {
                                return that.addContentsApprovalPop();

                            // 결재 여부가 없는 경우 메세지 팝업 후 창 닫기
                            } else {
                                SDLUtil.alert({
                                    title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                    msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                    onOkEvt: () => {
                                        that.closePopup();
                                    }
                                });
                            }
                        } else {
                            SDLUtil.alert({
                                title: "BUTTON.GLOBAL.CONFIRM",
                                msg: data.msg,
                                onOkEvt: () => {
                                    that.closePopup();
                                }
                            });
                        }
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                    });
        },
        // ## Contents 에서 사용하는 Button function : END

        // ## Contents 에서 사용하는 기타 function
        setAttachFiles(val) {
           Vue.$log.info('▶ InnorixUpload.vue -> KnowledgeContentsPopup.vue / files : ', val);
            this.attachFileSeq = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },
        // Parameter로 컨텐츠 검증 후 알림창
        validContentsAlert(params) {
            if(params.validId === 'PRD_CATEGORY_CD1')   return this.toastMsg(SDLUtil.getMsgProp('MESSAGE.DATA.SELECT.CATEGORY'));
            if(params.validId === 'KNOWLEDGE_TITLE')    return this.toastMsg(SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.REQUIRE.SUBJECT'));
            if(params.validId === 'KNOWLEDGE_DESC')     return this.toastMsg(SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.INSERT.DESCRIPTION'));
            if(params.validId === 'MODF_REASON')        return this.toastMsg(SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.INSERT.VERHISTORY'));
        },
        // 등록 시 최종 컨텐츠 검증 (필수값 위주)
        regVerifyContents() {
        	let bSymptomChk = false;
        	let bSymptom1Chk = false;
        	let bSymptomTarget = false;
            let validList = ['<br/>'];
            if(StringUtil.isNull(this.PRD_CATEGORY_CD1))validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.STEP.DESCRIPTION') + '&nbsp;' + SDLUtil.getMsgProp('MESSAGE.DATA.SELECT.CATEGORY')         + '</span>');
            if(StringUtil.isNull(this.KNOWLEDGE_TITLE)) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.STEP.DESCRIPTION') + '&nbsp;' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.REQUIRE.SUBJECT')    + '</span>');

            //20260626 ke01.liu SB knowledge tittle limt < 200 bytes
            if('SB' === this.params.menuGrpDetailCd || this.cttType === 'SB' || this.MENU_GROUP_DETAIL_CD === 'SB'|| 'RT' === this.params.menuGrpDetailCd || this.cttType === 'RT' || this.MENU_GROUP_DETAIL_CD === 'RT') {
            	if(StringUtil.textLength(this.KNOWLEDGE_TITLE) > 200) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + '[Subject]' + '&nbsp;' + ' The length of the subject input > 200  bytes. Please re-enter (Korean character as 3 bytes)'    + '</span>');
            }
//             else {
//             	if(StringUtil.textLength(this.KNOWLEDGE_TITLE) > 270) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + '[Subject]' + '&nbsp;' + ' The length of the subject input > 270  bytes. Please re-enter (Korean character as 3 bytes)'    + '</span>');
//             }

            if(('A' === this.PRD_CATEGORY_CD1 || 'C' === this.PRD_CATEGORY_CD1) && StringUtil.isNull(this.guideType) && ('SB' === this.params.menuGrpDetailCd || this.cttType === 'SB' || this.MENU_GROUP_DETAIL_CD === 'SB')){
                validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.STEP.DESCRIPTION') + '&nbsp;' + 'Please select Guide Type.' + '</span>');
            }

            // 이부분에 symptom 체크로직을 만들자.  20220118
            //console.log('this.isRepair ==> ', this.isRepair);          // service bulletin, repair tip 2가지 ???
            //console.log('this.isSCMSDirect ==> ', this.isSCMSDirect);  // CMS 에서 등록하니까  true 가 나와야 한다.
            //console.log('this.REPAIR_MENU ==> ', this.REPAIR_MENU);
            //console.log('this.SCMS_CONTENTS_CD ==> ', this.SCMS_CONTENTS_CD);
            console.log('this.cttType ==> ', this.cttType);
            //console.log('this.boardType2 ==> ', this.boardType2);
            //console.log('this.BOARD_TYPE2 ==> ', this.BOARD_TYPE2);
            console.log('this.MENU_GROUP_DETAIL_CD ==> ', this.MENU_GROUP_DETAIL_CD);
            console.log('this.params.menuGrpDetailCd ==> ', this.params.menuGrpDetailCd);
            //console.log('this.getSelBoardType2 ==> ', this.getSelBoardType2);
            //console.log('this.symptomList.length ==> ', this.symptomList.length);

            if( this.MENU_GROUP_DETAIL_CD === 'RT' || this.params.menuGrpDetailCd === 'RT' || this.cttType === 'RT' ) bSymptomTarget = true;
            if( this.MENU_GROUP_DETAIL_CD === 'SB' || this.params.menuGrpDetailCd === 'SB' || this.cttType === 'SB' ) bSymptomTarget = true;
            if ( bSymptomTarget ) {
	            if(this.symptomList.length > 0 ) {
	            	for(let i = 0; i < this.symptomList.length; i++) {
	            		if(!StringUtil.isNull(this.symptomList[i].SYMPTOM_TYPE) ) {
	            			bSymptomChk = true;
	            		}
	            		if(!StringUtil.isNull(this.symptomList[i].SYMPTOM_TYPE1) ) {
	            			//console.log('this.symptomList[i].SYMPTOM_TYPE1 ==> ', this.symptomList[i].SYMPTOM_TYPE1);
	            			bSymptom1Chk = true;
	            		}
	            	}
	            }

	            //console.log('bSymptomChk ==> ', bSymptomChk);
	            //console.log('bSymptom1Chk ==> ', bSymptom1Chk);
	            if((!bSymptomChk) || (!bSymptom1Chk) ) {
	            	validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.STEP.DESCRIPTION') + ' Please select a Symptom. </span>');
	            }
            }

            // CrossEditor blank check
            const CEblankTxt = "<p><br /></p>";
            let knowledgeDesc = window[this.getEditorId].GetValue(),
                knowledgeDescBody = _.replace(window[this.getEditorId].GetBodyValue(), /(\r?\n)/g, '');

            let bulletinTemp = document.createElement('html'),
                //repairTemp   = document.createElement('html'),
                callTemp     = document.createElement('html'),
                blankTemp    = document.createElement('html');

                bulletinTemp.innerHTML = ServiceBulletinTemp,
                //repairTemp.innerHTML = RepairTipTemp,
                callTemp.innerHTML = CallGuideTemp,
                blankTemp.innerHTML = BlankTemp;

            if(
                StringUtil.isNull(knowledgeDescBody)
             || knowledgeDescBody === CEblankTxt
             || knowledgeDescBody === bulletinTemp.getElementsByTagName('body')[0].innerHTML.trim()
             //|| knowledgeDescBody === repairTemp.getElementsByTagName('body')[0].innerHTML.trim()
             || knowledgeDescBody === callTemp.getElementsByTagName('body')[0].innerHTML.trim()
             || knowledgeDescBody === blankTemp.getElementsByTagName('body')[0].innerHTML.trim()
            ) {
                validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.STEP.DESCRIPTION') + '&nbsp;' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.INSERT.DESCRIPTION') + '</span>');
            };

            /*
             * SCMS Contents 의 경우 Model 필수 - 2020.06.03 삭제
            if(this.isSCMSContents) {
                if(this.modelList.length === 0) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.STEP.MODELLISTS') + '&nbsp;' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.INSERT.MODELLIST') + '</span>');
            };
            */

            // ke01.liu 20241106  MUST READ
			//if( (this.MENU_GROUP_DETAIL_CD === 'SB' || this.params.menuGrpDetailCd === 'SB' || this.cttType === 'SB')  ){
			if(('SB' === this.params.menuGrpDetailCd || this.cttType === 'SB' || this.MENU_GROUP_DETAIL_CD === 'SB' || 'KSBL' === this.params.menuGrpDetailCd || this.cttType === 'KSBL' || this.MENU_GROUP_DETAIL_CD === 'KSBL') && (this.PRD_CATEGORY_CD1 === 'A' || this.PRD_CATEGORY_CD1 === 'C')) {
				if(this.mustreadYn && this.serialList.length > 0){
					if(StringUtil.isNull(this.serialList[0].SERIAL_S)){
						validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.STEP.DESCRIPTION') + '&nbsp;' + 'Please input the Serial Number' + '</span>');
					}
				}
				if(this.mustreadYn && StringUtil.isNull(this.partsList)){
					validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + '[Part Lists Step]' + '&nbsp;' + 'Please add the Part list' + '</span>');
				}
            };

            if(StringUtil.isNull(this.versionDesc) || this.versionDesc.length < 20) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.STEP.VERSIONHISTORY') + '&nbsp;' + SDLUtil.getMsgProp('FIELD.KNOWLEDGE.VERSION.PLACEHOLDER') + '</span>');

            if(validList.length > 1) {
                SDLUtil.alert({
                    title: 'TITLE.KNOWLEDGE.VERIFY.CONTENTS',
                    msg: SDLUtil.getMsgProp('MESSAGE.KNOWLEDGE.VERIFICATION') + validList.join(''),
                    class: 'sm_size'
                });

                return false;

            } else {
                return true;
            }
        },
        // 한 줄 팝업 (토스트 메세지)
        toastMsg(msg = "Alert") {
            return Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
        },

        // Check Point : 컨텐츠 생성 팝업 닫기 전 어떠한 이벤트를 넣어야할지 확인 필요.
        closePopup(rtnFlag = '') {
            let that = this;
            Vue.$log.info('▶ KnowledgeContentsPopup.vue close event.', rtnFlag);
            // Knowledge delete/expire, Bug report complete 이 후는 confirm 이 아닌 alert 으로 대체
            if(rtnFlag === 'DKD') {
                SDLUtil.alert({
                    title: 'MESSAGE.POPUP.CLOSE',
                    msg: 'MESSAGE.DATA.DELETED',
                    okLabel: 'BUTTON.GLOBAL.CLOSE',
                    onOkEvt: () => { that.rtnFunc({ flag: rtnFlag }); that.$emit('close'); },
                });

            // Expire 종료 처리
            } else if(rtnFlag === 'EKD') {
                SDLUtil.alert({
                    title: 'MESSAGE.POPUP.CLOSE',
                    msg: 'MESSAGE.DATA.EXPIRED',
                    okLabel: 'BUTTON.GLOBAL.CLOSE',
                    onOkEvt: () => { that.rtnFunc({ flag: rtnFlag }); that.$emit('close'); },
                });

            // 버그리포트 Close 처리
            } else if(rtnFlag === 'BUG') {
                axios.post(
                    `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/bugReport/settle.skp`,
                    qs.stringify({ BUG_REPORT_ID: that.bugReportId }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    let data = res.data;
                    if(data.msg) {
                        SDLUtil.alert({
                            title: 'MESSAGE.POPUP.CLOSE',
                            msg: 'MESSAGE.DATA.UPDATE.SUCCESS',
                            okLabel: 'BUTTON.GLOBAL.CLOSE',
                            onOkEvt: () => { that.rtnFunc({ flag: rtnFlag }); that.$emit('close'); },
                        });
                    };
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });

            } else {
                SDLUtil.alert({
                    msg: 'MESSAGE.DATA.CLOSE.SUCCESS',
                    okLabel: 'BUTTON.GLOBAL.CLOSE',
                    onOkEvt: () => {
                        Vue.$log.info('▶ KnowledgeContentsPopup.vue closePopup no rtnFlag =>', rtnFlag);
                        that.rtnFunc({ flag: rtnFlag });
                        that.$emit('close');
                    },
                });
            }
        },
        // KnowledgeId 가 있지만 데이터가 삭제된 경우 경고창을 띄운 후 종료
        notFoundKnowledge(e) {
            SDLUtil.showLoadingBar(false);
            SDLUtil.alert({
                title: 'TITLE.WARNING.TITLE',
                msg: 'MESSAGE.DATA.DELETECHECK',
                okLabel: 'BUTTON.GLOBAL.CLOSE',
                onOkEvt: () => { this.rtnFunc({ flag: 'NFK' }); this.$emit('close'); },
            });
        },

        checkProductTypeAndGudideType(){
        	let that = this;
        	if(that.verifyUseYn || that.isSCMSDirect){
        		if('SB' === that.params.menuGrpDetailCd || 'SB' === that.cttType || 'SB' === that.MENU_GROUP_DETAIL_CD ){
        			if(that.guideType === 'M' || (that.PRD_CATEGORY_CD1 === 'B' && that.guideType === 'S')){
        				return false;
        			}else{
        				return true;
        			}
        		}else{
        			return true;
        		}
        	}else{
        		return false;
        	}
        }


    },
    created() {
        Vue.$log.info('▶ KnowledgeContentsPopup.vue created.', (this.knowledgeId ? '/ KnowledgeId : ' + this.knowledgeId : ''));
        SDLUtil.showLoadingBar(true);
        this.initLoad();
    },
    mounted() {
        this.$nextTick(() => {
            // 나모에디터 유동적 로딩을 위한 초기 로딩
            SDLUtil.importJS(`${this.$CONTEXT}/static/js/crosseditor/js/namo_scripteditor.js`)
                .then(() => {
                    this.isImportNamo = true;
                })
                .catch(err => {
                    this.$log.error(err);
                });

            if(!this.isLoading) {
                // SCMS Field 정의
                this.setSCMSField();
            };
        });
    }
};
</script>
<style>
.zindex9999 { z-index: 9999; }
.top20 {top: -20px;}
.float-none {float: none;}
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeContentsPopup.vue